//Chinese
export const language = {
    //2020-10-26-ljm增加 弹窗提示以及翻译
    meassage: {
        leanMore: '了解更多',
        skip: '跳過',
        activate: '激活',
        emailSend: 'Email sent!',
    },
    leftBanner: {
        liteFile: 'Lite File',
        logoSlogan: '跨雲蝶傳輸的首選工具',
        cloudEscription: '跨雲端資料傳輸，就選MultCloud',
        commonTools: '常用工具',
        cloudDrives: '我的雲端硬碟',
        onlineServices: '我的在線服務',
        switchTxt: '切換到經典版MultCloud',
        taskList: '工作列表',
        cloudTransfer: '跨雲碟傳輸',
        cloudSync: '雲端硬碟同步',
        cloudBackup:'雲端硬碟備份',
        btLink: '遠端任務',
        teamTransfer:'團隊遷移',
        shares: '分享管理',
        emailTransfer: '郵件傳送',
        instagramDownload: 'Instagram下載器',
        videoDownload: '視頻下載器',
        webDownload: '網頁圖片下載器',
        addCloud: 'Add Cloud',
        addEmail: 'Add Email',
        encryption: '加密',
        edit: '重新添加',
        remove: '移除',
        createTask: '創建任務',
        createTaskText: '您可以在此處創建最常用的任務.',
        gotIt: '收到指令',
        bigWriteEncrypt: '加密',
        encryptionText: '您可以在此處設定雲端檔案加密.',
        addCloudText: '點擊這裡將您的雲端硬碟和電子郵件連接到MultCloud。',
        inviteFriends: '邀請朋友',
        switchTip: '切換到經典版',
        switchTipDes: '您可以在此切換到經典版。',
        new: '新',
    },
    common: {
        addCloud: '添加雲端硬碟',
        addEmail: '添加電子郵件',
        options: '選項',
        schedule: '排程',
        ok: '確定',
        save: '保存',
        add: '添加',
        upgradeNow: '立即更新',
        from: '來源',
        to: '目的地',
        result: '結果',
        fileProcess: '檔案進度',
        transferFiles: '檔案',
        dataProcess: '數據進度',
        startTime: '開始時間',
        currentRate: '當前速度',
        endTime: '結束時間',
        timeRemaining: '剩餘時間',
        averageRate: '平均速度',
        averageRateSpecial: '平均速度',
        viewFailed: '點選查看失敗檔案',
        fileSuccess: '成功傳輸所有檔案',
        size: '大小',
        executedTimes: '執行次數',
        sourceDir: '源目錄',
        cause: '原因',
        retry: '重試',
        retryMin: '重試',
        clean: '清除',
        properties: '屬性',
        copy: '複製',
        move: '移動',
        multiSelect: '多選',
        close: '關閉',
        copyTo: '複製到',
        tranTo: '傳輸到',
        syncWith: '同步到',
        backupTo: '備份到',
        download: '下載',
        delete: '刪除',
        more: '更多',
        preview: '預覽',
        share: '分享',
        shareWith: '使用MultCloud共用',
        shareTransfer: '創建傳輸任務',
        encrypt: '加密',
        encryptFile: '僅加密檔案',
        encryptFileName: '加密檔案和名稱',
        decrypt: '解密',
        decryptFile: '僅解密檔案',
        decryptFileName: '解密檔案和名稱',
        onedriveBusinessContentNote: '註',
        oneDrive4BusinessContent: '如果您是管理員並且已向使用者指派了Microsoft 365許可證，但在嘗試透過MultCloud存取使用者的資料夾時收到「存取被拒絕」錯誤，請嘗試下列步驟：',
        oneDrive4BusinessTips1: `前往「<a href="https://admin.microsoft.com/" target="_blank" class='add-onedrivebuiness-link'>管理</a> 」。選取「用戶 」> 點選「激活用戶 」選項 > 選取「管理產品許可證」選項。`,
        oneDrive4BusinessTips2: '轉到「OneDrive 」選項卡，然後按一下「建立檔案連結 」。然後，返回MultCloud並嘗試再次存取該帳戶。',
        oneDrive4BusinessStep1: '步驟1',
        oneDrive4BusinessStep2: '步驟2',
        upStep: '上一步',
        nextStep: '下一步',
        complete: '完成',
        cut: '剪下',
        viewDetails: '查看詳情',
        toOfficialSite: '官網',
        btLinkTask: '遠端任務',
        fileName: '檔案名',
        itemsSelected: '選擇的項目',
        dateModified: '修改日期',
        rename: '重命名',
        paste: '貼上',
        btLink: '遠端任務',
        load: '加載中',
        status: '狀態',
        operate: '作業',
        failure: '失敗',
        link: '複製鏈接',
        cleanList: '清除歷史記錄',
        type: '類型',
        account: '賬戶',
        name: '檔案名',
        selectFailedFile: '請選擇失敗檔案',
        transferring: '傳輸中',
        newPassword: '新密碼',
        confirmPassword: '確認密碼',
        done: '完成',
        no: '否',
        yes: '是',
        attention: '注意',
        cancel: '取消',
        unsubscribe: '取消訂閱',
        reactivate: '重新激活',
        sureCleanAll: '您確定要清除所有完成的任務？',
        failedFiles: '失敗檔案',
        minTo: '到',
        retryAll: '重試所有',
        viewProgress: '查看進程',
        taskNotRun: '此任務未運行。',
        success: '成功',
        failure: '失敗',
        canceled: '取消',
        patial: '部分成功',
        syncDetails: '同步細節',
        width: '寬度',
        sync: '同步',
        targetCloud: '目標雲端硬碟',
        running: '運行中',
        preparing: '準備中',
        waiting: '等待中',
        target: '目標',
        noVip: '目前您最多可以同時傳輸2個檔案。升級到任一高級服務可最多傳輸10個檔案！',
        vipThanks: '感謝您訂閱我們的服務。 現在，您最多可以同時傳輸10個檔案。',
        emailAccount: '電子郵件賬號',
        with: '目的地',
        syncing: '同步中',
        selectAll: '選擇所有',
        date: '日期',
        failed: '失敗',
        skip: '跳過',
        replace: '代替',
        ready: '等待複製',
        connecting: '連接中',
        account: '賬號',
        selectNull: '請選擇目標目錄。',
        selectOther: '無法選擇此目錄來粘貼文件，可以選擇其子目錄或其他目錄。',
        //2020-10-26-ljm新增
        filterHolder: '輸入檔案擴展名，例如：MP4',
        countFiles: '計數文件',
        //2020-8-18-xth新增
        editShare: '編輯分享',
        toSource: '跳轉到源檔案',
        copyLink: '複製分享連結',
        toShare: '跳轉到分享頁',
        report: '舉報',
        expand: '展開',
        shrink: '摺叠',
        //2020-12-2-ljm新增
        upgradeMulti: '升級執行緒',
        team: "團隊檔案",
        loadData: '資料載入中，請稍後',
        getAccountInfo: '無法獲取該賬號資訊，請重新登錄入後重試。',
        loadingData: '加載中 ...',
        failedEmptyTip: '無法載入失敗的檔案。請聯繫<a href="mailto:support@multcloud.com">support@multcloud.com</a>以獲得進一步的説明。',
        runNow: '立即運行',
        emailFilter: '電子郵件過濾',
        me: "我",
        reset: "重置",
        apply: "套用",
        failureReason: '失敗原因',
        countingFilesTip: '計算中（{num} 個檔案）',
        taskName: '任務名稱',
        frequency: '頻率：',
        canceling: '正在取消... ',
    },
    rightTopBanner: {
        navTransfer: '跨雲碟傳輸',
        navInstagram: 'Instagram下載器',
        navVideo: '視頻下載器',
        navWeb: '網頁圖片下載器',
        traffic: '數據流量',
        upgrade: '升級會員',
        settings: '設定',
        changePassword: '修改密碼',
        changeName: '更改名稱',
        bindEmail: '綁定電子郵件',
        deleteAccount: '刪除賬戶',
        language: '語言',
        help: '幫助',
        notifications: '通知',
        notification: '通知',
        subAccounts: '子賬戶',
        logout: '登出',
        tutorials: '使用教程',
        contact: '聯絡',
        limitsClouds: '雲端的限制',
        faq: '常見問答',
        purTraffic: '購買流量',
        unlimitedPlan: '高級會員',
        monthlyUnlimitedPlan: '月度無限方案',
        rememberOriginal: '請記住您的原始用戶名:',
        andPassword: '和密碼',
        bindEmailOpen: '為了您的賬號安全和使用便利，您最好<span style="color:#8a96e3;cursor:pointer;" id="bindEmailOpen">綁定您的電子郵件地址，并修改您的默認密碼 </span>。',
        lifeSwitchTip: '擁有終身無限服務，您可以在雲端硬碟間任意傳輸檔案，而不會受到數據流量的限制。',
        lifeTimePlan: '終身無限版',
        browserPrompt: '为了您有更好的使用体验，我们建议您使用Google Chrome。',
        unlimited: '無限',
        lifeTimeNotice: '您當前為MultCloud終身無限方案用戶。',
        subAccount: "子賬號",
        bindMailTips: "請綁定您的電子郵件以解鎖雲文件傳輸並充分利用MultCloud。",
        bind: "綁定",
    },
    popup: {
        userStarPopup: {
            starDesc: "評價您最近的經歷",
            ok: "提交",
            thankYou: "謝謝！",
            thankYouDesc: "如果您能抽出一點時間來分享您使用我們產品的真實和誠實的體驗，這將有助於我們的小團隊保持積極性，讓MultCloud變得更好。",
            reviewStart: "請前往",
            reviewEnd: "給予好評",
            feedbackTitle: "我們該如何改進？",
            feedbackDesc: "反饋您使用MultCloud時遇到的問題，我們將予以重視。",
            feedbackBtn: "提交",
            feedbackYes: "感謝您的反饋。",
            feedbackNo: "請輸入您的反饋意見。",
        },
        addCloudPopup: {
            endpointOptional:'端點（選填）',
            //2020.09.23 添加NAS云盘
            addNas: '添加 NAS',
            addNasFtpDes: `通過FTP連線到NAS。不知道如何為NAS設定FTP傳輸協議？請點選<a href="https://www.multcloud.com/help/enable-ftp-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>這裡</a>`,
            addNasWebDes: `通過WebDAV連線到NAS。不知道如何為NAS設定WebDAV傳輸協議？請點選<a href="https://www.multcloud.com/help/enable-webdav-service-on-synology-nas.html" target="_blank" class='add-cloud-link'>這裡</a>`,
            bucketName: '儲存貯體名稱',
            accessKeyId: '訪問密鑰ID',
            idriveKeyId: 'Access Key ID',
            secretAccessKey: '秘密訪問密鑰',
            idriveSecretAccessKey: 'Secret Access Key',
            endpoint: 'Endpoint',
            displayName: '顯示名稱',
            addFtp: '添加FTP',
            addFtpDes: '為了連結您的FTP，MultCloud需要您輸入身份驗證詳細信息。',
            icedriveTip: '注意：',
            icedriveTip1: '1. 僅支援添加Icedrive高級帳戶。',
            icedriveTip2:`2. 點擊您的lcedrive名稱 -> 2FA與訪問 -> WebDAV -> 啟用 -> 顯示密鑰。訪問密鑰即密碼。`,
            egnyteTip: `提示：要獲取您的 Key 和 Secret，您需要Egnyte API管理ID。如果沒有，您可以<a href="https://developers.egnyte.com/member/register" target="_blank" class='add-cloud-link'>在這裡註冊</a>。`,
            iCloudPhotosTip: '提示：',
            iCloudPhotosTip1: '1. 將iCloud照片連接到MultCloud之前，請確保「在網頁上取用iCloud資料」已開啟。',
            iCloudPhotosTip1Q: `如何管理iCloud資料在Web的取用：<br><br>在iPhone或iPad上<br>1. 開啟「設定」應用程式。<br>2. 點一下「您的名稱 」，然後點一下「iCloud 」。<br><br>3. 點一下按鈕以關閉或開啟「在網頁上取用iCloud資料 」。<br>
            <br>在Mac上<br>1. 選擇蘋果選單 > 「系統偏好設定 」。<br>2. 點一下「您的名稱 」，然後點一下「iCloud 」。<br>3. 點一下按鈕以關閉或開啟「在網頁上取用iCloud資料 」。`,
            iCloudPhotosTip2: '2. iCloud照片僅支援以下影像格式：jfif、pjpeg、jpeg、pjp、jpg、HEIC。',
            server: '伺服器',
            protocol: '協議',
            port: '埠口',
            passive: '被動模式',
            passphrase: '密碼短語',
            explanation: '要成功連結FTP，前綴應為"ftp://"或沒有前綴。如果您的FTP埠不是默認埠，則為特殊埠號碼，例如21,則請使用以下格式指定埠：ftp://ftp.myhost.com:21',
            userName: '用戶名',
            passWord: '密碼',
            advanced: '進階',
            commFTP: '常用FTP',
            transMode: '傳輸模式',
            encoding: '字符集編碼',
            path: '路徑（可選）',
            cloudName: '雲端名稱',
            cloudService: '雲端服務',
            addedTime: '添加時間',
            userName: '用戶名',
            usedSpace: '已用空間',
            totalSpace: '總共空間',
            iCloudUsedSpace: 'iCloud 相簿储存用量',
            iCloudDriveUsedSpace: 'iCloud 雲碟储存用量',
            iCloudTotalSpace: 'iCloud儲存空間總量',
            iCloudDriveTotalSpace: 'iCloud儲存空間總量',
            removeContent: '某些傳輸任務基於此雲端硬碟，您確定仍要移除它嗎？',
            google_driveTips: '從Google雲端硬碟將檔案或資料夾傳輸到其他雲端硬碟時，請確保同一目錄下沒有相同的檔案名。',
            baiDuTips: '您只能上傳或傳輸檔案到"全部文件/我的应用数据/MultCloud"目錄',
            mySQLQuestion: '您需要在伺服器字段中輸入MySQL伺服器的IP地址，默認埠為3306或輸入自定義埠。',

            webDavQuestion: `如果您使用SSL連接，則應在主機上添加“ https：//”前綴或省略，此時默認埠為443；否則，前綴應為“ http：//”，默認埠為80。  例如 https://dav.box.com/dav`,

            egnyteQuestion: '登錄Engnyte，然後在地址欄中找到您的域。 請以以下格式輸入域： https://aomeitech.egnyte.com/',

            ownCloudQuestion: '如果您使用SSL安全連接，則應在主機上添加“ https：//”前綴或不執行任何作業，此時默認埠為443；否則，前綴應為“ http：//”，默認埠為80。  例如 https://dav.box.com/dav',

            amazonQuestion: `訪問此頁面以了解<a href="https://www.multcloud.com/tutorials/s3-key.html" target="_blank" class='add-cloud-link'>如何獲得Amazon S3訪問秘鑰</a>。`,

            boxTips: `Box不支援傳輸大於2GB的單個檔案`,
            google_drive_sharedWithMeTips: '當您將檔案傳輸到「與我共用雲端硬碟」中的資料夾時，請確保您已獲得「上傳權限」。',
            gSuiteSharedDriveTips: '當您將檔案傳輸到「共用雲端硬碟」中的資料夾時，請確保您已獲得「上傳權限」。',
            webDavTips: `1.請在進行檔案作業前確認您具有讀寫權限，否則，MultCloud可能無法將檔案傳輸到WebDav中。
          2. 請確保有足夠的空間進行作業，我們暫時無法確定其大小。`,
            aDriveTips: '我們目前支援私人高級帳戶和企業帳戶，但不支援私人基礎帳戶。',
            yandexTips: `1.請確保有足夠的空間進行作業，我們暫時無法確定其大小。
                       2.如果您已啟用應用程式密碼，請在上面的密碼欄位中輸入該應用程式密碼。`,
            googlePhotosTips: `1.“Photos”目錄只能存儲圖像、視訊和其他媒體檔案，而不能存儲目錄。
          2.“Albums”目錄只能存儲影集目錄，而不能存儲媒體檔案。
          3.“Sharing”目錄包含您分享的所有相簿和您已加入的共享相簿。
          4.Google相簿僅支援上傳圖片、視訊和其他媒體檔案。 當您使用MultCloud上傳功能時，您只能將檔案上傳到MultCloud創建或分享的相簿目錄中。
          5.使用MultCloud源分享功能時，您只能分享MultCloud創建的相簿。
          6.所有無標題的相簿將顯示為“未命名”.
          7.當前，下載功能可用，但是不支援下載原始檔案。
          8.當前不支援剪切、刪除和重命名功能。並且您無法使用依賴這些作業的功能。 `,
            googlePhotosV2Tips: `1.“Photos”目錄只能存儲圖像、視訊和其他媒體檔案，而不能存儲目錄。
          2.“Albums”目錄只能存儲影集目錄，而不能存儲媒體檔案。`,
            evernoteTips: `1. API 速率限制。<a href='https://dev.evernote.com/doc/articles/rate_limits.php' target="_blank" class='add-cloud-link'>查看詳情>> </a>
            2. Evernote的系統限制是什麼？ <a href='https://help.evernote.com/hc/en-us/articles/209005247-What-are-the-system-limits-of-Evernote-' target="_blank" class='add-cloud-link'>查看詳情>></a>
            3. 您僅能將小於50MB的檔案上傳到筆記中。
            4. 無法重命名或刪除註釋內容檔案（.ENML）。
            5. 僅能將筆記複製到筆記本上。`,

            flickrTips: `1. 您只能將圖片或視訊傳輸到Flickr。
          2. 資料夾只能傳輸到“ Albmus”目錄，且“ Albums”下的目錄不能再有子目錄。
          3. 檔案只能被傳輸到“My Photostream”或“Albums”中您創建的目錄。
          4. 您的所有檔案都可以在“My Photostream”目錄下找到。
          5. “Albums”目錄下的所有檔案都會被引用到“My Photostream”目錄下。`,

            mediafireTips: '不支援上傳和下載空檔案。 打開包含很多檔案的資料夾可能會花費一段時間。',

            mySQLTips: `1. 您需要從我們的IP地址209.126。％訪問您的數據庫。 您可以通過數據庫或主機界面創建新用戶，MySQL命令列如下：
          <span class='add-mysql-link'>GRANT SHOW DATABASES, SELECT, LOCK TABLES, RELOAD ON *.* TO username@'209.126.%' IDENTIFIED BY 'password'</span>;
          2. 您的伺服器可能需要添加帶有我們的IP地址和訪問埠（默認埠為3306）的防火牆規則，才能正常訪問數據庫。`,
            hubiCTips: `1. 一個hubiC帳戶只能添加一次。
          2.您不能重命名和剪切檔案或資料夾。
          3. 刪除包含許多檔案的資料夾可能會有點慢。
          4. hubiC不支援傳輸超過5GB的單個檔案。
          5.檔案名稱不能超過248個字符，資料夾名稱不能超過256個字符。`,

            gSuiteUpTips: `要連接G Suite 和MultCloud，您需具有G Suite管理員權限。要將G Suite連接到MultCloud, 您需首先“域安裝”我們的 G Suite Marketplace app --- <a href='https://gsuite.google.com/marketplace/search/Cloud%20Transfer%20-%20MultCloud?hl=en' target="_blank" class='add-cloud-link'>"Cloud Transfer - MultCloud"</a> 。`,

            gSuiteTips: `1.您必須是<a href="https://support.google.com/a/answer/2405986?hl=en" target="_blank" class='add-cloud-link'> G Suite管理員</a>。
                      2.如何檢查它是否為管理員帳戶？ 首先，請參考此連結<a href='https://support.google.com/a/answer/2406043' target="_blank" class='add-cloud-link'> https://support.google.com/a/answer/2406043</a>。然後，從連結登錄您的Gsuite賬號。 最後，您可以在“創建自定義角色”列下找到結果。
                      3.已啟用<a href='https://support.google.com/a/answer/60757?hl=en' target="_blank" class='add-cloud-link'>API訪問</a>。
                      4.添加此雲端硬碟之前，您需要先安裝我們的<a href='https://gsuite.google.com/marketplace?hl=en' target="_blank" class='add-cloud-link'> G Suite Marketplace app </a> "MultCloud for G Suite" ，並確保其<a href='https://admin.google.com/' target="_blank" class='add-cloud-link'>設定</a>正確：狀態為開啟，並且已授予訪問權限。`,

            hiDriveTips: `1.在處理檔案之前，請確保您的帳戶已啟用WebDAV協議並具有讀取/寫入權限，否則MultCloud可能無法將檔案傳輸到您的HiDrive。
          2. 請確保有足夠的空間進行作業，我們暫時無法確定其大小。`,
            backblazeTips: `1.每個儲存貯體的名稱必須至少包含6個字符。
          2.當您創建新的應用程式密鑰時，舊的將不再起作用。
          3.檔案名不能以“ /”開頭，以“ /”結尾或包含“ //”。`,
            WEBDETips: `1.請在進行檔案作業之前確保您具有讀/寫權限，否則，MultCloud可能無法將檔案傳輸到Web.De中。
          2. 請確保有足夠的空間進行作業，我們暫時無法確定其大小。`,
            alfrescoTips: `作為免費的Alfresco賬號，您的網路存儲空間為10GB，單個檔案大小限制為50MB。`,
            cloudMeTips: `1.請在進行檔案作業前，確保您具有讀/寫權限。否則，MultCloud可能無法將檔案傳輸到您的CloudMe賬戶。
          2. 請確保有足夠的空間進行作業，我們暫時無法確定其大小。`,
            myDriveTips: `請確保有足夠的空間進行作業，我們暫時無法確定其大小。`,
            cubbyTips: `1.P請在進行檔案作業前，確保您具有讀/寫權限。否則，MultCloud可能無法將檔案傳輸到您的Cubby賬戶。
          2. 請確保有足夠的空間進行作業，我們暫時無法確定其大小。`,
            cloudType: '雲端硬碟類型',

            notificationTip: `感謝您使用最新的MultCloud，如果有任何問題，請反饋至:<a href="mailto:support@multcloud.com">support@multcloud.com</a>。非常感謝！`,

            notAbleAccess: '無法訪問Google相簿的問題已解決',

            problemNotAccess: '無法訪問Google相簿的問題已修復。 如果您仍然無法訪問Google相簿，請重新將其添加到MultCloud。',

            noPrompt: '不再提示',
            addFeatures: '以下是一些新增加的功能:',
            version: '版本:',
            applicationKey: '應用秘鑰',
            keyID: '密鑰ID',
            privateKey: '用於認證的私鑰檔案（可選）',
            FTPTips: `1.您需要有對FTP目錄與檔案的讀寫權限，否則可能無法進行操作。
          2.由於無法識別FTP的空間大小，請確保其有足夠空間。
          3.如果不能訪問你的FTP,請將209.126.103.1/19和207.38.89.1/24加到到防火墻白名單中。`,
            specialDropBox: `如果您是Dropbox Business管理員並且想要訪問您管理的所有帳戶，請點選“訪問團隊帳戶”。`,
            specialDropBoxBottom: `如果您想訪問您的個人雲端硬碟，請點選“訪問個人帳戶”。`,
            accessOrganization: '訪問團隊帳戶',
            accessPersonalCloud: '訪問個人帳戶',
            specialBoxBusiness: `如果您是商務用box管理員並且想要訪問您管理的所有帳戶，請點選“訪問團隊帳戶”。`,
            specialgSuite: `如果您是<a href='https://support.google.com/a/answer/2405986?hl=Hant' target="_blank" class='add-cloud-link'>Google Workspace 管理員</a>並且想要訪問您管理的所有帳戶，請預先在網域內安裝Google Workspace Marketplace中的應用程式 --- "<a href='https://gsuite.google.com/marketplace/app/cloud_transfer_multcloud/72136911391?hl=zh-Hant' target='_blank' class='add-cloud-link'>Cloud Transfer – MultCloud</a>"。然後點選“訪問團隊帳戶”。`,
            specialOnedrive: `如果您是商務用OneDrive管理員並且想要訪問您管理的所有帳戶，請點選“訪問團隊帳戶”。`,
            iCloudPhotosTips: 'MultCloud暫不支援沒有郵箱的Apple ID登入。',
            appleId: 'Apple ID',
            addICloudPhotos: '添加 iCloud 照片',
            addICloudDrive: '添加 iCloud 雲碟',
            fourShared: `註：4shared授權有效期限為<span style="color: red">2小時。</span>授權到期後，請重新添加4shared並手動執行您的任務。`,
            fourSharedTips: `註：4shared授權有效期限為2小時。授權到期後，請重新添加4shared並手動執行您的任務。`,
        },
        cloudExploerPopup: {
            googlePhotosV2Tips: 'Google相簿提示',
            googlePhotosV2TipsDesc: 'Google已於2025年5月7日更新了Google相簿API。為了適應這些變更，我們需要實施以下更新：',
            googlePhotosV2Tips1: '“相簿”資料夾現在僅顯示由MultCloud創建的相簿。',
            googlePhotosV2Tips2: '“照片”資料夾現在僅顯示透過MultCloud上傳的圖片。',
            googlePhotosV2Tips3: '要將圖片從Google相簿轉移到其他雲端服務，請點擊“新增更多照片”按鈕，並授予MultCloud存取您希望轉移的圖片的權限。',
            googlePhotosV2Tips4: '若要將其他雲端服務中的圖片傳輸到Google相簿，請注意，只能將資料夾傳輸到“相簿”資料夾，並且只能將單一圖片傳輸到“照片”資料夾。',
            googlePhotosV2TipsShow: '不要再顯示此訊息',
            googlePhotosV2AddMore: '新增更多照片',
            googlePhotosV2AddMoreTips: '點擊此處以新增您希望添加到MultCloud的圖片。',
            googlePhotosV2FolderName: '資料夾名稱',
            googlePhotosV2FolderNameInput: '輸入要儲存圖片的資料夾名稱',
            googlePhotosV2NotSelect: '您尚未新增任何照片。請點擊“新增更多照片”以將圖片添加到MultCloud。',
            googlePhotosV2SelectAlbums: '您只能將資料夾儲存到“相簿”',
            googlePhotosV2SelectAlbum: '您只能將圖片和影片儲存到此資料夾',
            googlePhotosV2SelectPhotos: '您只能將圖片和影片儲存到“照片”',
            googlePhotosV2SelectSession: '此資料夾無法選擇作為目標。請選擇“相簿”或“照片”資料夾。',
            deleteContentEver: '您確定要永久刪除所選項目嗎？<br>一旦刪除，就無法從垃圾桶中恢復。',
            deleteContent: '您確定要刪除所選項目嗎？',
            detailedProgress: '詳細進度',
            highSpeed: '快速搜尋支援以下雲端硬碟',
            takeMoreTime: '以下雲端硬碟或許還需要一些時間',
            enterKeyWord: '輸入關鍵字',
            highSpeedSearch: '快速搜尋',
            normalSearch: '正常搜尋',
            shareWithOthers: '與他人分享',
            inviteByEmail: '通過電子郵件邀請他人',
            pleaseEnterEmail: '請輸入電子郵件，並用逗號分隔',
            addMessage: '添加訊息（可選）',
            shareTo: '分享到',
            noLink: '尚未建立連結',
            createShare: '創建分享',
            cancelAllTask: '您確定要取消所有任務嗎?',
            //2020/8/7-xth
            shareEmailTitle: '通過電子郵件發送連結',
            shareNotSupportSource: '此雲端硬碟不支援此功能，請嘗試另一個雲端硬碟',
            shareSendEmail: '發送電子郵件',
            generateLinkSuccess: '分享連結已創建',
            generateLinkFail: '創建分享連結失敗',
            emailSentSuccessful: '電子郵件發送成功',
            emailSentNull: '您還未輸入電子郵件地址',
            emailSentNotice: '請輸入正確的電子郵件地址',
            linkCopySuccessful: '連結已復制！',
            sharePrivateLink: '私人分享連結：',
            sharePrivatePassword: ' 查看密碼：',
            cancelMyShareTask: '您確定要取消此分享？取消後此連結將不會再對任何人生效。',
            cancelMyShareOk: '是的，取消分享',
            cancelMyShareNot: '不，我要保留分享',
            emailArrayToLong50: '您一次可以發送50封個電子郵件。',
            shareOnEmail: '通過電子郵件發送連結',
            shareOnFacebook: '分享到Facebook',
            shareOnTwitter: '分享到Twitter',
            shareOnTumblr: '分享到Tumblr',
            shareOnPinterest: '分享到Pinterest',
            shareOnLinkedIn: '分享到LinkedIn',
            ceateShareError: '分享失敗，請檢查您的網路。'
        },
        cloudTransferPopup: {
            pleaSelect: '請選擇',
            schedule: '排程',
            checkScheduled: '請點選此任務中的“計劃”以激活排程設定.',
            addValidCloud: '您需要添加一個有效的雲端硬碟',
            //2020-10-26-ljm增加
            cleanList: '清空'
        },
        personalCenter: {
            changePassword: ' 更改密碼',
            changeName: '更改名稱',
            deleteAccount: ' 刪除賬戶',
            enterPassWord: '請輸入您的密碼',
            note: '注意：請告訴我們您離開的原因，我們將盡力予以糾正。',
            sureDeleteAccount: '您確定想刪除這個賬戶嗎？',
            unsubscribe: '刪除此帳戶之前，請先取消訂閱MultCloud.',
            bindEmail: '綁定電子郵件',
            pleaseSwitch: '請切換至經典版MultCloud以解密檔案。',
            switchOld: '切換至經典版',
            pleaseUnsubscribe: '請切換至經典版MultCloud，以取消您訂閱的高級服務。',
            deletePremium: '您將刪除一個高級賬號。一旦刪除，您將無法再恢復這個賬號。您確定要刪除此賬號嗎？'
        },
        remoteTaskPopup: {
            addLinkTask: ' 添加連結任務',
            validLink: '請輸入有效連結',
            saveCloud: '保存到雲端',
            parseFail: '解析失敗',
            inadmissibleRequest: '不支援該任務',
            createBtTask: '創建BT任務',
            emptySource: '請輸入一個連結或上載一個種子檔案',
            validTorrent: '無效種子檔案',
            addTorrent: '添加種子',
            tip: '請選擇一個雲端硬碟以保存該檔案',
            torrentSelected: '檔案名 ({num}/{all})',
            urlLinkSupported: '請在這裡複製和貼上連結，支援http/https/magnet連結,\n注意：請不要使用MultCloud下載和上載侵權內容',
            torrentStore: '請選擇儲存此種子檔案的雲端硬碟',
            downloadLink: '請輸入下載連結',
            cancelTask: '取消任務',
            cancelTaskContent: '您確定要取消任務嗎？',
            parseTaskRunning: 'MultCloud已經開始運行解析過程，請轉到“遠端上載”以查看'
        },
        taskListPopup: {
            deleteTask: '刪除任務',
            pleaseSelect: '請先選擇任務，然後再刪除。',
            sureDeleteTask: '您確定要刪除這些任務嗎？',
            deleteSingleTask: '您確定要刪除此任務嗎？',
            viewLogs: '查看日誌',
            selectCloud: '請選擇雲端硬碟以保存檔案',
        },
        upgradeAccountPopup: {
            commonTitle: '同時運行5個雲到雲任務',
            commonDes: '請升級到訂閱用戶，您將能夠同時運行5個雲到雲任務。',
            upgradeAccount: '升級賬號',
            upgradeHeadTitle: '同時執行5個連結或種子任務',
            upgradeHeadContent: '免費用戶可以同時執行1個連結或種子任務。升級成為訂閱用戶可以同時執行5個連結或種子任務',
            currentPlan: '當前方案',
            insufficientTraffic: '雲端到雲端流量不足',
            insufficientTrafficDes: '您已經消耗了本月的所有免費數據流量。 為了獲得更多流量，請升級到高級版本。',
            filter: '檔案傳輸/同步過濾器',
            filterDes: '要激活檔案傳輸/同步過濾器，請升級到高級版本。',
            offlineFree: '同時執行1個連結或種子任務',
            offlinePremium: '同時執行5個連結或種子任務',
            modes: '進階同步模式',
            modesDes: '訂閱用戶享有雙向同步模式以及7種可自定義的單向同步模式，且支援增量備份同步模式。',
            offlineFree: '同時執行1個連結或種子任務',
            doubleRealTime: '同時執行兩個實時同步任務',
            doubleRealTimeSyncDes: '若想同時執行兩個實時同步任務，請先升級為訂閱賬號。',
            doubledSync: '同時執行兩個普通同步任務',
            doubleSyncDes: '若想同時執行兩個普通任務，請先升級為訂閱賬號。',
            realTimeSyncing: '同時執行兩個實時同步任務',
            norMalSyncing: '同時執行兩個普通同步任務',
            free: '免費',
            premium: '高級版本',
            monthTraffic: '5GB 數據流量/月',
            syncMode: '2種同步模式',
            scheduled: '定期的傳輸/同步/備份',
            scheduledDes: '要啟動排程功能，請升級到高級版本。',
            moreTraffic: '更多數據流量',
            moreSyncModes: '8種同步模式',
            transferSpeed: '5倍速傳輸速度',
            doubleSync: '雙重同步',
            transferServer: 'VIP傳輸伺服器',
            customerSupport: 'VIP用戶支援',
            syncSupported: '雙向同步和7種自定義的單向同步模式。 支援鏡像同步。 ',
            greatlyIncreased: '訂閱用戶可享有10個線程，而不是2個，因此傳輸速度大大提高。',
            sameTime: '訂閱者可以同時執行2個實時同步和2個常規同步任務（總共4個）。',
            normalSametime: '訂閱用戶可同時運行2個普通同步任務',
            automatically: '"設定過濾器以對用戶指定檔案名"或具體擴展名的檔案進行傳輸或同步。',
            multipleSync: '多目標雲碟同步',
            multipleSyncDes: '請升級成為付費用戶來解鎖同步至多個目標雲端硬碟。',
            freeDes: '免費用戶每月有30GB的數據流量，以在雲端存儲服務之間傳輸和同步資料。',
            task1: '同時運行1個雲到雲任務',
            task5: '同時運行5個雲到雲任務',
            emailTitle: '郵件轉換額度不足',
            emailDes: '免費用戶每月可轉換50封郵件，但您需要的似乎不止于此。升級至高級版本，暢享無限郵件轉換。',
            emailsConversions: '50封郵件轉換/月',
            emailsUn: '50封邮件转换/月',
        },
        remindBindEmail: {
            bindExe: '請綁定您的電子郵件以執行任務',
            onceBind: ' 綁定電子郵件後，您還可以獲得<span class="gift-flow">30GB</span>的額外的雲端到雲端數據傳輸流量！',
            bindEmail: '請綁定郵箱，以啟動MultCloud的核心功能。',
            coreFeatures: 'Multcloud核心功能',
            tourAccount: '遊客賬號',
            connectCloud: '連接雲端硬碟到MultCloud',
            viewCloud: '通過MultCloud查看所有雲端檔案',
            uploadFile: '通過MultCloud上傳檔案到雲端硬碟',
            downloadCloud: '通過MultCloud下載雲端檔案',
            syncAndBackup: '在雲端硬碟之間同步和備份檔案',
            transferFiles: '將一個雲端硬碟的檔案傳輸到另一個雲端硬碟',
            failed: '執行該操作失敗，請稍後再試。'
        },
        salePagePopup: {
            sOffer: '“月無限”特別推薦',
            timeLimited: '時間有限, 趕快行動!',
            Hours: '時',
            Minutes: '分',
            Seconds: '秒',
            monthPrice: '$19.9/月',
            dataTra: '即可獲得無限流量',
            subscribe: '立即訂閱',
            features: '主要功能',
            freePlan: '免費方案',
            bigSale: '限時大優惠',
            discountsto: '折扣低至',
            off: '75折',
            premiumPlan: '付費方案',
            transmit: '傳輸數據流量',
            dataTraffic: '從一個硬盤到另一個硬盤的數據流量',
            originalPrice: '原價',
            nowOnly: '現價',
            getDiscount: '立即購買',
            moreData: '更多傳送流量',
            unlimitedData: '無限傳送流量',
            syncModes: '更多跨雲碟同步模式',
            syncModesDes: '訂閱用戶可使用雙向同步以及7種單向同步方式，支援鏡像同步。',
            scheduleTran: '定時傳輸',
            scheduleTranDes: '有了此功能，您可以在固定時刻或特定時間段安排自動雲到雲傳輸任務。',
            transferSpeedDes: '訂閱用戶會獲得10個傳送線程（免費用戶為2個）進行跨雲碟檔案傳送/同步，傳輸速度也因此會獲得極大提升',
            fileEncryption: '檔案加密',
            encryptFiles: '訂閲用戶可以在綫加密雲端硬碟中的檔案和上傳的檔案。',
            quarterly: '每季',
            yearly: '每年',
            monthGb: '150GB/每月',
            monthGbly: '200GB/每月',
            monthfourLy: '400GB/每月',
            unTr: '無限數據流量',
            nMonth: '/月',
            tQuarter: '/季',
            eYear: '/年',
            tOneTime: '一次性',
            //2021-10-09
            premiumFeatures: '一個月150GB流量和所有高級功能！',
            unlimitedYear: '一年無限流量和所有高級功能!',
            unlimitedLiftime: '終身無限流量和所有高級功能!',
        },
        properties: '屬性',
        general: '一般',
        tips: '提示',
        progress: '進程',
        limits: '雲端硬碟的限制',
        detailed: '詳細',
        cancel: '全部取消',
        simpleSync: '簡單同步',
        onewaySync: '單向同步',
        twowaySync: '雙向同步',
        advancedSync: '進階同步模式',
        mirrorSync: '鏡像同步',
        moveSync: '移動同步',
        cmuSync: '累積同步',
        updateSync: '更新同步',
        increSync: '增量同步',
        fullSync: '完全備份同步',
        simpleSyncTip: '在源目錄中添加、修改和刪除的檔案將會被複製到目標目錄中；但在目標目錄中添加、修改和刪除的檔案不會被複製到源目錄。',
        mirrorSyncTip: '始終保持目標目錄與源目錄中的檔案完全一致（MultCloud 會刪除目標目錄中多餘的檔案）。',
        moveSyncTip: '同步完成後，自動刪除源目錄中的所有檔案。',
        cmuSyncTip: '刪除源目錄中的檔案時，將不會刪除目標目錄中的相同檔案。',
        updateSyncTip: '首先刪除目標目錄中的所有檔案，然後將源目錄中添加和修改的檔案傳輸到目標目錄。',
        increSyncTip: '每次同步檔案時，都會在目標目錄中創建一個子目錄，以便將源目錄中添加和修改的檔案傳輸到該目錄。',
        fullSyncTip: '在每次同步時，會在目標目錄中自動建立一個子目錄，並將源目錄中所有檔案轉移到這個子目錄中。',
        twowaySyncTip: '源目錄中添加、修改和刪除的檔案將被複製到目標目錄。 同樣，目標目錄中添加、修改和刪除的檔案也將被複製到源目錄（即：源目錄和目標目錄中的檔案始終相同）。',
        syncModes: '同步模式',
        email: '電子郵件',
        filter: '過濾',
        once: '一次',
        thread: '執行緒',
        listThread: '遍歷執行緒數',
        runThread: '執行執行緒數',
        filterInclude: '包含的檔案副檔名（例如：png、doc、mp4）',
        filterExclude: '排除的檔案名稱（例如：target、dist、build）',
        newFilterTag: '新增標籤',
        createTaskStatus: '已建立',
        pendingTaskStatus: '等待中',
        runningTaskStatus: '執行中',
        cancelledTaskStatus: '已取消',
        completedTaskStatus: '成功',
        failedTaskStatus: '失敗',
        warnTaskStatus: '警告',
        errorTaskStatus: '錯誤',
        warning: '警告',
        logs: '日誌',
        daily: '每日',
        weekly: '每週',
        monthly: '每月',
        onlyOnce: '僅在這個時間運行一次:',
        everyDay: '每天這個時間運行:',
        everyWeek: '每週的:',
        at: '具體時刻:',
        sunday: '週日',
        monday: '週一',
        tuesday: '週二',
        wednesday: '週三',
        thursday: '週四',
        friday: '週五',
        saturday: '週六',
        runAt: '在此時運行:',
        lastDay: '最後一天',
        chooseAction: '目標檔案是否已存在。請選擇一個動作:',
        optionsPrompt: '如果源雲端硬碟中的檔案具有目標雲端硬碟中不允許的檔案名特殊字符，則檔案將在傳輸過程中自動重命名，並且將在目標雲端硬碟的根目錄中創建log.html檔案。',
        sourceNewer: '如果源較新，則覆蓋。',
        diffSize: '如果大小不同則覆蓋。',
        sourceAll: '如果大小不同或源更新，則覆蓋。',
        skipFile: '跳過此檔案。',
        skipEmail: '直接略過該郵件，不傳輸。',
        overWrite: '始終覆蓋。',
        rename: '重命名',
        overWriteSourceNewer: '若原郵件存在更新，則覆蓋。',
        deleteAllSource: '傳輸完成後，刪除所有源檔案。',
        keepFileDate: '保留檔案修改日期（支援Dropbox、Google雲端硬碟、G Suite）。',
        automaRename: '使用特殊字符自動重命名檔案並生成腳本檔案。',
        sendEmail: '完成此任務時發送電子郵件通知。',
        sendMessage: '發送測試訊息',
        ignoreFiles: '忽略具有這些擴展名的檔案',
        includeFiles: '僅包括具有這些擴展名的檔案',
        selectSync: '您可以在此處選擇同步模式:',
        tipsFor: '提示',
        allTasks: '所有任務',
        successful: '成功',
        unfinished: '未完成',
        transferDetails: '傳輸明細',
        redit: '重新編輯',
        publicShare: '公開分享',
        publicTip: 'Tips:任何擁有連結的人都可查看此檔案',
        privateShare: '私人分享',
        privateTip: 'Tips:其他人需要輸入密碼才能查看檔案',
        sourceShare: '來源分享',
        sourceTip: 'Tips:創建源雲端硬碟的分享連結',
        shareSuccess: '成功創建分享',
        copySuccess: '複製成功',
        sharedYet: "檔案已被分享",
        domain: '域',
        key: 'Key',
        secret: 'Secret',
        //2020-10-26-ljm增加
        progressBox: '進度框',
        //xth
        publicShareEasy: '任何人',
        privateShareEasy: '私人分享',
        communityShareEasy: '公共',
        sourceShareEasy: '源分享',
        reportPopup: {
            title: '舉報分享',
            beforeMsgOne: '請幫助我們了解此連結發生了什麼。',
            beforeMsgTwo: '此連結有什麼問題？',
            typeItems: {
                spam: '垃圾郵件',
                malwareVirus: '惡意軟體或病毒',
                copyrightViolation: '侵犯版權',
                illegal: '非法內容',
                notWorking: 'MultCloud沒有正常工作',
                other: '其他不當內容',
            },
            nextMsgOne: '請填寫舉報的內容。',
            description: '描述',
            nextMsgTwo: '請說明此連結發生了什麼',
            yourEmail: '您的電子郵件地址',
            nextMsgThree: '請提供您的電子郵件地址，如有需要，我們將會聯絡您。',
            submit: '提交',
            back: '返回',
            next: '下一頁',
            messageNone: '請輸入舉報的詳細內容。',
            emailNone: '請輸入您的電子郵件地址。',
            success: '您的舉報內容已發送至 MultCloud團隊。'
        },
        subAccountPopup: {
            title: "子帳號管理",
            titleMax: "子帳號管理",
            titleDes: "升級成為付費用戶，即可解鎖子賬號相關功能。",
            tabNameUser: "使用者模式",
            tabNameItem: "資料夾模式",
            addItemButton: "分配資料夾",
            users: "使用者",
            folders: "資料夾",
            read: "讀",
            write: "寫",
            questionTxtRead: "子帳號使用者可以下載、預覽此資料夾中的檔案，並將其複製自己的雲端硬碟中。",
            questionTxtWrite: "子帳號使用者可以創建新資料夾，上載、刪除和重命名此資料夾中的檔案。",
            userExist: "使用者已經存在。",
            userSelf: "請勿將自己的賬號添加為子賬號。",
            quickAssign: "快速分配",
            quickAdd: "快速添加",
            allow: "允許",
            batchAddUserNull: "還未添加使用者。",
            batchAddItemNull: "還未添加資料夾。",
            noUserFromAddItem: "請先添加使用者。",
            noItemFromAddUser: "請先添加資料夾。",
            addUser: {
                title: "添加使用者",
                radioCreate: "創建一個子帳號",
                radioAdd: "添加一個現有的MultCloud帳號",
                createNamePlaceholder: "創建使用者名稱",
                createPasswordPlaceholder: "創建密碼",
                addNamePlaceholder: "請輸入現有的MultCloud帳號",
                createNameNone: "請填入一個使用者名稱。",
                createNameMore: "使用者名稱應少於20個字符。",
                createPasswordNone: "請輸入密碼。",
                createPasswordError: "請輸入8-16個字符的密碼。",
                addUserNameNone: "請輸入一個現有的MultCloud帳號。",
                addUserNone: "此帳號不存在。",
            },
            addItem: {
                noFolder: "請選擇一個資料夾。",
                exist: "您已經添加了該資料夾。",
            },
            editUser: {
                title: "編輯子帳號",
                namePlaceholder: "輸入使用者名稱",
            },
            cancel: {
                titleUser: "刪除子帳號",
                titleItem: "移除資料夾",
                msgUser: "您確定要刪除此帳號嗎？",
                msgItem: "您確定要移除此資料夾嗎？",
            },
            unknownError: "找不到路徑，請檢查路徑是否存在或重新添加雲端硬碟。",
        },
        verifyPopup: {
            verifyTitle: "驗證您的身份",
            toRecoveryText: "沒有這些驗證方式",
            verifyEmailTitle: "驗證您的電子郵件地址",
            verifyEmailTips: "我們將向 {email} 發送驗證碼。為了驗證此電子郵件地址，請在下方輸入。",
            verifyPhoneTitle: "驗證您的電話號碼",
            verifyPhoneTips: "我們將向 {phone} 發送驗證碼。若要驗證這是您的電話號碼，請輸入最後 4 位數字，包括 {last}。",
            verifyPhoneText: "電話號碼最後4位數字",
            sendCodeBtn: "發送驗證碼",
            enterCode: "輸入驗證碼",
            checkEmailTips: "如果 {email} 與您賬號中的備用電子郵件地址匹配，我們將向您發送驗證碼。",
            checkPhoneTips: "如果 {phone} 與您賬號中電話號碼的最後 4 位數字匹配，我們將向您發送驗證碼。",
            askDevice: "信任該設備。",
            verify: "驗證",
            recoveryTitile: "您是否有賬號恢復驗證碼？",
            recoveryTipsOne: "如果您有恢復驗證碼，請立即輸入。如果您沒有，請聯繫",
            recoveryTipsTwo: "您的恢復驗證碼有 25 個字符長，如下所示：XXXXX-XXXXX-XXXXX-XXXXX-XXXXX。",
            recoveryCode: "恢復密碼",
            recoveryCodeBtn: "使用恢復密碼",
            recoveryChangeTitile: "還有什麽能驗證您的身份？",
            recoveryEmailChange: "添加備用電子郵件地址",
            recoveryPhoneChange: "添加電話號碼",
            enterEmail: "輸入您的電子郵箱",
            recoveryNextTitle: "請輸入發送給 {checkCode} 的驗證碼",
            recoveryTipsTitle: "安全起見，更換您的安全資料需要 30 天！",
            recoveryTips1: "因為您開啟了兩步驗證，您需要最新的安全驗證資料來登入您的賬號。",
            recoveryTips2: "在此期間，您將無法使用您的賬號登入網站或服務，但可以透過信任設備登入。",
            recoveryTips3: "您可以通過以下方式避免等待：",
            recoveryTips4: "使用受信任的設備。",
            recoveryTips5: "如果您的設備不需要驗證，可立即使用它並更新您的安全資料。",
            recoveryTips6: "找到您的安全驗證資料。",
            recoveryTips7: "有可能賬號沒有完全丟失？如果能找到，請立即使用它來重新啟用您的賬號。",
            recoveryTips8: "等候期間，其他人很難用盜取的密碼來登入您的賬號。",
            recoveryPendTitle: "您的安全資料更改還未完成",
            recoveryPendTips1: "您在 {data} 請求替換您的安全驗證資料",
            recoveryPendTips2: "當前安全驗證資料",
            recoveryPendTips3: "備用電子郵件地址：",
            recoveryPendTips4: "電話號碼：",
            recoveryPendTips5: "新的安全驗證資料",
            recoveryPendTips6: "如果您想保留當前安全驗證資料，",
            recoveryPendTips7: "取消此請求。",
            recoveryCancelTitle: "這是新的恢復密碼",
            recoveryCancelTips1: "為了您的賬號安全，您需要獲取一個新的恢復密碼。",
            recoveryCancelTips2: "如果您需要恢復對賬號的訪問權限，此密碼將有所幫助。您可以將其寫下來並將其存放在安全的地方。我們強烈建議您不要將恢復驗證碼存儲在設備上。",
            recoveryCancelTips3: "之前的恢復密碼將不再有效。改用這個新的恢復密碼。",
            recoveryCancelTips4: "您的新密碼是：",
            recoveryCancelSucTitle: "超贊！重新回到您的賬號！",
            recoveryCancelSucTips1: "{old} 的安全驗證資料更新已被取消，現在您可以安心訪問您的賬號。",
            recoveryCancelSucTips2: "改用 ({new})作為您驗證資料的請求已被取消，不會用作您賬號的安全驗證資料。",
            recoveryCancelSucTips3: "點擊 \"下一步\" 回到之前的作業。",
            recoveryCancelErrorTitle: "提交請求",
            recoveryCancelErrorTips: "您的賬號還處於等待期。",
            codeText: "請輸入您的電話號碼",
            exception: {
                emailTwoStringError: "有效的電子郵件地址以 \"{errorCode}\" 開頭。",
                validEmail: "請輸入有效的電子郵箱。",
                phoneLastTwoStringError: "有效的數字以 {errorCode} 結尾。",
                validPhone: "您必須輸入電話號碼的最後 4 位數字。",
                verifyCodeExpired: "驗證碼已過期。",
                verifyCodeError: "驗證碼不正確，請檢查驗證碼並重試。",
                verifyRecoveryCodeExpired: "驗證碼無效，請檢查驗證碼並重試。",
                verificationCodeNull: "請輸入驗證碼。",
            },
        },
        worldBackupPopup: {
            // title:'世界備份日',
            title: 'MultCloud特別優惠',
            titleTip: '24小時閃購',
            timerTitle: '該優惠活動有時間限制，抓緊時間搶購。',
            getOffer: '獲取報價',
            tips100Mo: '100GB/月流量數據',
            ps100Mo: '小貼士：未使用的數據流量會累積。例如。您在第一個月只消耗了100GB中的50GB，下個月您仍然會有50GB的額外數據流量。',
            tips1200Yr: '1200GB/年流量數據',
            ps1200Yr: '小貼士：未使用的數據流量會累積。例如。第一年你只消耗了1200GB中的1000GB，下一年你還有200GB的額外數據流量。',
            tips2400Yr: '2400GB/年流量數據',
            ps2400Yr: '小貼士：未使用的數據流量會累積。例如。第一年你只消耗了2400GB中的2000GB，下一年你還有400GB的額外數據流量。',
            tipsUnYr: '年度無限數據流量',
            psUnYr: '小貼士：一年無限流量！',
            tipsUnLi: '終身無限數據流量',
            psUnLi: '小貼士：終生無限流量！',
            tips1: '10個線程傳輸檔案',
            tips2: '定期的雲端傳輸',
            tips3: '24/7/365優先支援',
            ps1: '訂閱者有10個線程，免費用戶有2個，所以傳輸速度大大提高。',
            ps2: '訂閱者可以安排定期或在特殊時間點自動執行雲到雲傳輸/同步任務。',
            moPrice: '{price}/月',
        },
        iosPayTipPopup: {
            title: '取消Apple訂閱',
            tip: '您當前的{name}處於自動續訂狀態（Apple交易ID：{id}），請取消訂閱，然後重試。',
            btnTxt: '如何取消？',
        },
        appRecommendPopup: {
            title: '新的MultCloud移動應用程式現已推出！',
            tip: '立即下載以使用行動裝置跨雲端硬碟管理和傳輸檔案。',
            modileTitle: '立即獲取MultCloud移動應用程式！',
            iosBtnTitle: '下載',
            iosBtnTip: 'App Store',
            androidBtnTitle: '立即下載',
            androidBtnTip: 'Google Play',
            apkBtnTitle: '下載',
            apkBtnTip: 'MultCloud',
        },
        note: '提示',
        editCloudNoticPopup: {
            tips: '授權已過期，請將雲端硬碟重新添加到MultCloud，然後重試。',
            btnTxt: '重新添加',
        },
        appleTipsPopup: {
            title: '提示',
            tipTitle: '關於iCloud照片雙重認證提示',
            tip1: '要將iCloud照片連接到MultCloud，您需要授權MultCloud伺服器訪問您的Apple ID。因此，在雙重認證的過程中，您可能會察覺我們的伺服器定位與您的實際定位不同。',
            tip2: '您的安全性與隱私權是我們的首要任務。MultCloud可能會根據您的作業暫時緩存部分內容，但不會永久儲存，一旦作業完成，這些數據將立刻從我們的伺服器中清除。您的iCloud照片與MultCloud伺服器之間的連接始終透過安全的256位SSL憑證完成。',
            checkTip: '不再顯示',
        },
        iCloudDriveTips: {
            title: '提示',
            tipTitle: 'iCloud雲碟雙重認證提示',
            tip1: '要將您的iCloud雲碟連接到MultCloud，您需要授權MultCloud伺服器訪問您的Apple ID。因此，在雙重認證的過程中，您可能會看到我們的伺服器位置與您的實際位置不同。',
            tip2: '您的安全性和隱私權是我們的第一要務。MultCloud可能會根據您的作業暫時緩存部分內容，但不會永久儲存。一旦完成作業，這些數據會立即從我們的伺服器中刪除。您的iCloud雲碟和MultCloud伺服器之間的連接始終透過安全的SSL 256位元協議完成。',
            checkTip: '不再顯示',
        },
        checkApplePopup: {
            title: '雙重身份驗證',
            tip1: '您已打開雙重身份驗證。請在iPhone/iPad/iPod上輸入驗證碼以繼續。',
            tip2: '沒有收到驗證碼？',
            btn1: '正在發送……',
            btn2: '重新發送驗證碼',
            btn3: '給我發簡訊',
            btn4: '獲取支援',
            suc1: '帶有驗證碼的消息已發送到{num}。',
            suc2: '帶有驗證碼的消息已發送到您的設備。',
            fail1: '驗證碼發送失敗，請重試。',
            fail2: '請輸入驗證碼以繼續。',
        },
        downloadThreadPopup: {
            title: "下載設定",
            tips: "下載檔案的名稱",
            defaultNameOne: "Emails saved on {date}",
            defaultName: "{num} emails saved on {date}",
            option1: "保存副本",
            option2: "對話格式",
            option2Tips: "勾選時郵件引用的內容將會被移除。",
            option3: "僅保留最後一條訊息",
        },
        failedFilesPopup: {
            title: '查看失敗檔案：{num} 個',
            exportExcel: '匯出為Excel表格',
            retrySucTip: '{num} 項 已加入至重試清單.',
        },
        viewLogsPopup: {
            title: '任務詳情：',
            titleRe: '還原詳情：',
            errorNum: '失敗數量',
            addNum: '新增檔案',
            updateNum: '修改檔案',
            deleteNum: '刪除檔案',
            syncSize: '同步大小',
            syncTime: '同步耗時',
            backupNum: '備份數量',
            backupSize: '備份大小',
            backupTime: '備份耗時',
            tranNum: '傳輸數量',
            tranSize: '傳輸大小',
            tranTime: '傳輸耗時',
            from: '來源：',
            to: '目標：',
            executeTime: '執行時間：',
            sourceAccount:'來源帳戶',
            targetAccounts:'目标账户',
            executeResult: '執行結果',
            add: '新增：',
            update: '更新：',
            delete: '刪除：',
        },
        taskProgressPopup: {
            title1: '您是高級用戶，現在可同時使用10個執行緒傳輸檔案。',
            title2: '升級至任一高級服務，即可享有最多10個執行緒！',
            btnTip: '僅需$9.99起',
        },
        subfileSelectPopup: {
            title: '選擇上傳內容',
        },
        deleteBatchPopup: {
            tips1: '確定要刪除這 <span>{num}</span> 個任務嗎？',
            tips2: '任務刪除後將無法恢復',
        },
        freeSaledPopup: {
            tips1: '聖誕節大放送！免費領取50GB額外雲端到雲端傳輸空間——無限制，零費用！',
            tips2: '等一下！',
            tips3: '看起來你要跳過你的聖誕禮物了。提醒一下：一旦跳過，就不能再領取囉！',
            btns1: '領取 50GB',
            btns1: '不用了，謝謝',
            success: '恭喜！您剛獲得 50GB 的跨雲端傳輸流量。',
            floatTitle: '免費 50GB',
            popupTitle: '免費 <span>50GB</span>',
        }
    },
    addCloud: {
        connectDesc: '點選雲端硬碟以將其連結到MultCloud',
        box: 'box',
        boxBusiness: 'box for Business',
        dropbox: 'Dropbox',
        google_drive: 'Google雲端硬碟',
        google_drive_sharedWithMe: 'Shared with me',
        google_drive_v2: 'Google雲端硬碟',
        google_drive_shared_v2: 'Shared with me',
        oneDrive: 'OneDrive',
        oneDriveV2: 'OneDrive',
        sugarSync: 'SugarSync',
        amazonS3: '亞馬遜S3',
        iDrivee2: 'IDrive® e2',
        wasabi: 'Wasabi',
        webDav: 'WebDAV',
        FTP: 'FTP',
        cloudMe: 'CloudMe',
        cubby: 'Cubby',
        NAS: 'NAS',
        myDrive: 'MyDrive',
        yandex: 'Yandex',
        hiDrive: 'HiDrive',
        WEBDE: 'WEB.DE',
        baiDu: '百度雲',
        amazon: 'Amazon',
        alfresco: 'Alfresco',
        aDrive: 'ADrive',
        Icedrive: 'Icedrive',
        oneDrive4Business: '商務用 OneDrive',
        dropbox4Business: 'Dropbox Business',
        pCloud: 'pCloud',
        mega: 'MEGA',
        backblaze: 'Backblaze',
        putio: 'Putio',
        googlePhotos: 'Google相簿',
        googlePhotosV2: 'Google相簿',
        gSuiteSharedDrive: 'Shared Drive',
        evernote: 'Evernote',
        flickr: 'Flickr',
        mediafire: 'Mediafire',
        ownCloud: 'ownCloud',
        mySQL: 'MySQL',
        gSuite: 'Google Workspace',
        hubiC: 'hubiC',
        egnyte: 'Egnyte',
        youtube1: 'youtube1',
        facebook: 'facebook',
        picasa: 'picasa',
        goDaddy: 'goDaddy',
        ubuntu: 'ubuntu',
        welcomeTo: '歡迎來到MultCloud',
        peCloud: '個人雲端硬碟',
        buCloud: '企業雲端硬碟',
        welcomeFont: '現在您可以僅在一個平台輕鬆傳輸和管理多個雲端硬碟檔案。首先，請先將雲端硬碟連結到MultCloud。',
        sharePointOnline: "SharePoint Online",
        iCloudPhotos: 'iCloud照片',
        gmail: 'Gmail',
        comingSoon: '敬請期待...',
        iCloudDrive: 'iCloud 雲碟',
        signInWith: '登入',
        outlook: 'Outlook',
        fourShared: '4shared',
    },
    addEmail: {
        connectDesc: '選取您想要加入MultCloud的郵箱',
        peEmail: '選取並使用電子郵件登入',
        iCloudNotice: 'iCloud雲碟暫時無法連接，我們的開發團隊目前正在努力解決問題。',
        iCloudPhotosNotice: 'iCloud照片暫時無法連接，我們的開發團隊目前正在努力解決問題。',
    },
    cloudExploer: {
        uploadFile: '上載檔案',
        newFolder: '新資料夾',
        newAlbum: '新增相簿',
        search: '搜尋',
        grid: '格網',
        pageList: '清單',
        reFresh: '重新載入',
        modified: '修改於',
        openWith: '打開',
        officeOnline: 'Microsoft Office Online',
        loading: '請稍候，正在加載＃',
        uploadFolder: '上載資料夾',
        trash: '垃圾桶',
        recentlyDeleted: '最近刪除',
        jumpTo: '跳到',
        deleteForever: '永久刪除',
        restore: '恢復',
        back: '返回',
        searchResult: '搜尋結果',
        emptyTrash: '清空回收站',
        recoverAll: '全部復原',
        deleteAll: '全部刪除',
        fileExists: '檔案存在',
        chooseOption: '檔案存在，請選擇一個選項！',
        needRestore: '要查看此資料夾，您需要將其從回收站中還原',
        limitBoxTip: '1.小部分雲端硬碟可能會有一些限制。 例如：Box不支援傳輸單個大於2GB的檔案。 此類限制由雲端服務商設定，MultCloud無法打破它。 想了解更多信息，請<a href="https://www.multcloud.com/tw/help/limitations.html" target="_blank" class="add-cloud-link">點選此處</a>。<br> 2。 如果升級到高級版本後您的傳輸任務仍然沒有享用到10個線程，請取消并重新設定傳輸任務。 然後您的傳輸程式將獲得VIP專屬的10個線程傳輸服務。',
        fileNameNotEmpty: '您輸入的檔案名稱不能為空。',
        notContainSpecialChar: '檔案名稱不能包含特殊字符`/ \ | : * ? " < >`。',
        CharacterLimit: '檔案名稱不能包含特殊字符`~"# %& *: < >？ / \ { | }.`',
        pathNotExist: '路徑不存在',
        emptyNotice: '這個文件夾是空的',
        trashEmpty: '回收站為空',
        searchEmpty: '搜索結果為空',
        uploadSize: '上載任務的總大小不能超過1GB。',
        simultaneous: '您最多可以同時添加200個任務。',
        notWith: '文件名和文件夾名不能以“.”開頭或結尾。',
        notUpload: '上傳失敗。',
        duplicatePhoto: '照片重複。你正嘗試上傳的照片為重複項目，因此並未輸入至你的圖庫中。',
        dataLoaded: '數據加載完畢',
        sharedDate: '分享日期',
        failedRestore: '還原文件失敗，因為目標目錄包含具有相同文件名的文件。',
        //2020-12-11 lijimin
        uploadError: '此檔案已被雲端硬碟官方禁止下載。',
        downloadLimit: '您已達到今日的下載次數限制，歡迎明天再試哦！',
        //2022-4-26 wt
        newBucket: '新建存儲桶',
        createBucket: '存儲桶名稱應僅包含小寫字母和數位。長度應為 3-63 個字元。p.s. 儲存桶名稱不能全部為數位（即“12345678”）',
        deleteBucket: 'MultCloud 無法刪除具有所有數位命名約定（即“12345678”）的存儲桶。',
        getBucketObjectListFail: 'MultCloud 無法列出具有所有數字命名約定的存儲桶（即“12345678”）。',
        newAlubm: '',
        specialCharError: '檔案名稱不能包含特殊字符`/ | : * ? " < >`。',
    },
    emailExploer: {
        from: '寄件者',
        to: '收件者',
        cc: '副本',
        email: '電子郵件',
        subject: '主題',
        received: '收件時間',
        sentTime: '發件時間',
        downloadMax200: '一次最多可以下載 200 封電子郵件',
        noSubject: '(無主旨)',
        folderName: {
            Inbox: '收件匣',
            Starred: '已加星號',
            Snoozed: '已延後',
            Sent: '寄件備份',
            Drafts: '草稿',
            Important: '重要郵件',
            Chats: '即時通訊記錄',
            Scheduled: '已排定時間',
            AllMail: '所有郵件',
            Spam: '垃圾郵件',
            Trash: '垃圾桶',
            Unread: '未讀郵件',
            Categories_Social: '類別_社交網路',
            Categories_Updates: '類別_最新快訊',
            Categories_Forums: '類別_論壇',
            Categories_Promotions: '類別_促銷內容',
            Categories_Personal: '類別_個人',
        }
    },
    imageSaver: {
        analyzing: '分析中',
        failedToParse: '解析失敗',
        noviceGuidance: '您可以在這裡檢查所有最近上傳到雲端的圖片/影片，或是已打包的 Instagram 圖片/影片。',
        insDownloadExist: '您已經下載了此Instagram個人資料，您可以在“工作列表”中找到它。',
        taskExpiredOn: '已於 {time} 過期',
        taskStoringTill: '儲存到 {time}',
        taskPart: 'Part',
        taskUnitFile: '檔案',
        taskUnitFiles: '個檔案',
        taskQueue: '排隊中',
        taskTabUpload: '上傳',
        taskTabSaveAll: '全部儲存到雲碟',
        taskTabDownload: '下載所有的IG內容',
        downloadInsVideo: '下載影片',
        downloadSinglePost: '下載整個貼文',
        downloadAllPosts: '下載所有貼文',
        downloadAllReels: '下載所有Reels',
        downloadAllStories: '下載所有限時動態',
        downloadAllHighlights: '下載所有精選',
        saveInsVideo: '將影片儲存至雲碟',
        saveSinglePost: '將整個貼文儲存至雲碟',
        saveAllPosts: '將所有貼文儲存至雲碟',
        saveAllReels: '將所有Reels儲存至雲碟',
        saveAllStories: '將所有限時動態儲存至雲碟',
        saveAllHighlights: '將所有精選儲存至雲碟',
        insCardPosts: '貼文',
        insCardFollowers: '粉絲',
        insCardFollowing: '已關注',
        insTabPosts: '照片與影片',
        insTabReels: 'Reels',
        insTabStories: '限時動態',
        insTabHighlights: '精選',
        insBlankText: '使用MultCloud的Instagram下載器，可輕鬆下載並儲存Instagram的貼文、影片、故事和精華，隨時管理您最喜愛的內容。',
        webGoogleBlankText: '輕鬆從任何網站或Google搜尋中收集圖片並將其直接儲存到您的雲碟或本地儲存中。',
        noTask: '暫無任務',
        inputTipHttp: '輸入網站網址或Google搜尋關鍵字',
        fetchBtn: '立即獲取',
        fetchingBtn: '正在擷取中...',
        loadMore: '載入更多',
        downloadAll: '全部下載',
        saveAll: '全部儲存到雲碟',
        saveToCloud: '儲存至雲碟',
        clearHistory: '清除歷史紀錄',
        cancel: '取消',
        retry: '重試',
        view: '檢視',
        noImage: '沒有找到內容',
        notSupport: '可能不支援該URL。請仔細檢查後再試一次。',
        inputTipIns: '輸入Instagram網址',
        post: '帖子',
        posts: '個帖子',
        uploadTo: '上傳到：',
        download: '下載',
        uploading: '正在上傳',
        finished: '已完成',
        all: '所有',
    videoInputTip: '在此貼上您的影片連結',
        videoTip: `使用MultCloud的無廣告、跨平台線上影片下載器從YouTube、Facebook、X和<a href="https://www.multcloud.com/help/video-downloader.html" target="_blank" style="text-decoration: underline;color: #5562B4;">1000+個其他網站</a>下載高品質影片 — 無需安裝。`,
        process: '處理中...',
        thumbnail: '縮圖',
        abrTypeVeryHigh: '超高',
        abrTypeHigh: '高',
        abrTypeNormal: '標準',
        abrTypeLow: '低',
        default: '預設',
        generat: '檔案生成中',
        retryTip: '任務已重新啟動，可在「所有」標籤中查看最新進度。',
    },
    taskList: {
        taskListDes: '您可以在此處管理雲端傳輸、雲端同步和共享檔案保存任務',
        multiCloudSync: '多雲端硬碟同步',
        MultiCloudTransfer: '多雲端硬碟傳輸',
        nextTransfer: '下次傳輸',
        scheduled: '計劃',
        nextSync: '下次同步',
        reTransfer: '重新傳輸',
        saveNow: '立即保存',
        transferTasks: '傳輸任務',
        syncTasks: '同步任務',
        shareTasks: '分享任務',
        backupTasks: '備份任務',
        emailTransferTasks: '郵件傳送任務',
        allTime: '一直',
        today: '今天',
        latestWeek: '最近的一個星期',
        latestMonth: '最近的一個月',
        customDate: '自定日期',
        allStatus: '所有狀態',
        preset: '預設值',
        noTaskCreated: '沒有任務被創建',
        createTransferTask: '創建一個傳輸任務',
        createSyncTask: '創建一個同步任務',
        createRemoteTask: '創建一個遠端任務',
        timeMustLess: '開始時間必須早於或等於結束時間',
        taskNameRule: '任務名稱不能超過255個字符',
        backupTaskNameRule: '任務名稱不能超過255個字符',
        detailNote: '此任務仍在準備中，無法展示更多詳細程式。',
        notTraffic: '沒有足夠的數據流量進行雲到雲的傳輸。',
        cancelFailed: '取消失敗,任務正在創建中，請稍候重試',
        reSync: '重新同步',
        rebackup: '重新備份',
        rerestore: '重新還原',
        //2021-10-11
        createBackupTask: '創建一個備份任務',
        createTeamTransferTask: '創建團隊遷移任務',
        multiClouds: '多雲服務',
        speedUP: '加速',
        noTasks: '無任務',
        noTasksTip: '開始您的第一個任務，解鎖無縫的雲端傳輸與同步功能。',
        loadingTip: '請稍候。',
        allTasks: '全部任務（{num}）',
    },
    cloudTransfer: {
        transferDescription: '設定傳輸任務以在雲端硬碟之間傳輸檔案',
        transferOperateFrom: '點選此處以選擇要從其傳輸的雲端硬碟或資料夾',
        from: '來源',
        to: '目的地',
        transferOperateTo: '點選此處以選擇您要傳輸到的雲端硬碟或資料夾',
        transferNow: '立即傳輸',
        transfer: '傳輸',
        addTaskOnly: '僅添加任務',
        addTaskNow: '添加任務並立即傳輸',
        addSyncTaskNow: '添加任務並立即同步',
        addBackupTaskNow: '添加任務並立即備份',
        transferSucces: '成功傳輸',
        sureContinue: '您已經選擇了超過10個源項目，每個源項目對應一封電子郵件通知。這意味著您可能會收到超過10封電子郵件。您確定要繼續嗎？',
        sure: '是的，我確定。',
        //2020-10-29ljm新增
        sourceRemind: '最多選擇200個源項目。請減少選擇的源項目或直接選擇一整個資料夾。P.S：一整個資料夾只算作一個項目。',
        backupSourceRemind: '最多選擇1000個源項目。請減少選擇的源項目或直接選擇一整個資料夾。P.S：一整個資料夾只算作一個項目。'
    },
    cloudSync: {
        syncDescription: '設置同步任務以在雲端硬碟之間同步檔案',
        syncOperateTo: '點選此處以選擇要同步到的雲端硬碟或資料夾',
        syncOperateFrom: '點選此處以選擇要從其同步的雲端硬碟或資料夾',
        syncNow: '立即同步',
        taskEmpty: '任務名不能為空.',
        //2020-10-29ljm新增
        aimRemind: '最多選擇200個目標目錄。',
        realTimeSync: '實時同步',
        normalSync: '常規同步',
        pause: '暫停',
        paused: '已暫停',
        swicthTwoWay: '切換到雙向同步',
        switchOneWay: '切換到單向同步',
        fristSync: '首次同步',
        lastSync: '上次同步',
        initSync: '資料初始同步仍在進行中，請稍候。',
        realSyncing: '實時同步運行中...',
        servicesSu: '支援實時同步的雲端硬碟',
        addRealDrives: '您需要添加支援實時同步的雲端硬碟。',
        egDrives: '目前，MC僅支援在Google Drive，Dropbox，Dropbox Business，OneDrive，OneDrive for Business，G Suite，Box 中運行實時同步。',
        initTial: '初始化',
        realSync: '實時同步',
        createdAt: '創建時間',
        oneWaySimple: '單向(簡單同步)',
        twoWay: '雙向(即將推出...)',
        gooleFolder: '如果只有Google Drive資料夾的子目錄發生變化，那麽此次同步不會執行。',
        realTimeNotice: '您最多可以同時運行2個實時同步任務，因此一些子任務將被暫停。你確定要繼續嗎？',
        reachMax: '日誌數量已達到最大值，因此僅顯示最新的日誌。',
        notRun: '任務還未執行。',
        bePaused: '如果實時同步任務保持非運行狀態超過 7 天，它將自動暫停。',
        dontShow: '不再顯示此內容',
        timeOut: '遍歷超時',
        outMostly: '遍歷超時主要是因為需要實時同步的檔案太多或子目錄太多。我們建議您創建一個常規同步任務。'
    },
    emailTransfer: {
        cloudEmail: '郵件傳送',
        description: '將您的電子郵件以PDF格式傳輸到雲端。',
        migrationSetting: '傳送設定',
        cutSetting: '剪下-設定',
        copySetting: '複製-設定',
        settingTips: '',
        notification: '通知',
        watermark: '水印',
        delWatermark: '從下載為PDF的郵件移除浮水印',
        saveAtt: '保存副本',
        converFormat: '對話格式',
        converFormatTip: '勾選時郵件引用的內容將會被移除。',
        saveOnly: '僅保留最後一條訊息',
        optionTitle: '一些電子郵件已經存在，您想如何處理這些電子郵件？',
        filterTitle: '您可以為來源選取框指定額外的過濾條件。',
        filterMessage: '請輸入電子郵件，並用逗號隔開',
        filterOption1: '如果會話已更新則覆蓋它',
        filterOption2: '總是跳過',
        filterOption3: '重命名',
        filterOption4: '有附件',
        filterOption5: '未讀郵件',
        transferNow: '立即傳輸',
        filterDateOptions1: '不限時間',
        filterDateOptions2: '一週以上',
        filterDateOptions3: '超過1個月',
        filterDateOptions4: '超過6個月',
        filterDateOptions5: '超過1年',
        filterDateOptions6: '自訂日期範圍...',
        showMore: '顯示更多',
        startDate: '開始日期',
        endDate: '結束日期',
    },
    exception: {
        exceedMaxLimit: '請求數量超過了最大數量。',
        addCloudFailed: '某些雲端硬碟參數輸入不正確。',
        cloudNameExist: '此名稱重複，請輸入另外的雲端硬碟名稱。',
        pathNotFound: '檢查指定路徑下的檔案或資料夾是否存在。',
        notBeTheSame: '源資料夾和目標資料夾不能相同。',
        notTransferring: '無法選擇此目錄以傳輸檔案，請選擇其子目錄或其他目錄。',
        verifyCodeInvalid: '驗證碼錯誤',
        nameEmpty: '顯示名稱不能為空',
        emailEmpty: '電子郵件不能為空',
        serverEmpty: '服務器不能為空',
        usernameEmpty: '用戶名不能為空',
        passwordEmpty: '密碼不能為空',
        domainEmpty: '域不能為空',
        bucketNameEmpty: 'Bucket Name不能為空',
        accessKeyEmpty: 'Access Key ID不能為空',
        secretAccessKeyEmpty: 'Secret Access Key 不能為空',
        keyIdEmpty: 'keyID不能為空',
        applicationKeyEmpty: 'applicationKey不能為空',
        sugarSyncWarn: '不支援複製到所選目錄，請選擇"Web Archive","Magic Briefcase","Mobile Photos"目錄。',
        flickWarn: '不支援複製到所選目錄，請選擇 "/Albums" 目錄。',
        baiDuWarn: '不支援複製到所選目錄，請選擇 "全部文件/我的应用数据/MultCloud"目錄。',
        dropBoxbusinessWarn: '不支持複製到根目錄，請選擇其他目錄。',
        notMediaFiles: '注意: "Albums" 目錄只能儲存相簿目錄，而不能儲存具體檔案。',
        notStoreDirectories: '"Photos" 目錄下不能儲存目錄。',
        onlyStoreImages: '注意:"Photos" 目錄下只能儲存圖片、視訊和其他檔案，但不能儲存目錄。',
        unknownError: '無法連結此服務，請重新授權MultCloud存取服務。',
        renameCloudFailed: '重命名雲端硬碟失敗，請稍後重試。',
        deleteCloudFailed: '刪除雲端硬碟失敗，請稍後重試。',
        invalidCloudAccount: '此雲端硬碟賬號不存在。',
        bindEmailFail: '綁定電子郵件失敗。',
        linkHasExpired: '連結已過期。',
        listItemsFailed: '列出檔案失敗，請重新加入雲端硬碟到MultCloud。',
        deleteItemFailed: '刪除項目失敗。',
        renameItemFailed: '重命名項目失敗。',
        createFolderFailed: '創建資料夾失敗。',
        moveItemFailed: '移動項目失敗。',
        shareItemFailed: '分享項目失敗。',
        uploadFailed: '找不到檔案數據。',
        toFolderIdBlanked: '“提示”為空白。',
        downloadFileFailed: '下載檔案失敗，請重新載入此頁面，或重新添加雲端硬碟到MultCloud。',
        addTaskFail: '添加任務失敗',
        taskQuotaLimit: '您已經達到了1000個雲端到雲端傳輸任務的最大數量，請刪除一些不重要的任務。',
        deleteTaskFail: '刪除任務失敗。',
        maxRunningLimit: '正在運行的任務超過了最大數量，可以將該任務添加為等待中的任務。',
        userCreateFail: '創建用戶失敗，請稍後重試。',
        userUpdateFail: '修改帳號信息失敗，請重新加載此頁面，然後重試。',
        createSaltFail: '創建鹽失敗，請重試。',
        listFolderFailed: '列出資料夾失敗，請重新添加此雲端硬碟。',
        cloudCategoryInvalid: '不再支援此雲端。',
        executeTaskFail: '無法執行任務，請檢查您的網路連結。',
        parameterInvalid: '參數無效。',
        saltInvalid: '登入失效，請重新登入。',
        emailInvalid: '此電子郵件無效。',
        notAuthorized: '用戶名或密碼不正確。',
        cloudNameEmpty: '顯示名稱不能為空。',
        addCloudExpired: '添加雲端硬碟失敗，請重新添加雲端硬碟。',
        verifyCodeInvalid: '驗證碼無效。',
        emailExist: '電子郵件已經存在。',
        exceedMaxLimit: '請求超過了最大數量。',
        userIdNotNull: '用戶ID為空。',
        notFoundTask: '找不到任務。',
        noTaskRunning: '沒有任務正在運行。',
        userNotFound: '找不到用戶。',
        loginerNotFound: '不支援此登錄器。',
        ipNotFound: '找不到IP。',
        deletePermissionLimited: '無法進行此作業，因為您沒有“刪除權限”',
        notHaveDeletePermission: '您無權刪除該檔案/資料夾。',
        uploadPermissionLimited: '無法進行此作業，因為您沒有“上傳權限”',
        movePermissionLimited: '您不能继续进行这项操作，因为您没有 "移動權限"',
        copyPermissionLimited: '您不能继续进行这项操作，因为您没有 "復製權限"',
        notHavePermission: '由於缺乏寫入權限，您無法貼上此檔案/資料夾。',
        mkdirPermissionLimited: '無法進行此作業，因為您沒有“創建資料夾權限”',
        notCreatPermission: '由於缺乏寫入權限或空間不足，您無法創建存取桶或資料夾。',
        renamePermissionLimited: '無法進行此作業，因為您沒有“重命名權限”',
        creatIDriveFolderError: '物件名稱包含不支援的字元。',
        creatIDriveFolderToLong: '資料夾名稱不能超過245個字元。',
        noUploadPermission: '由於缺乏上傳權限或雲端磁碟空間不足，您無法上傳此檔案。',
        bucketNameLongError: '儲存桶名稱長度必須為3到63個字符，只能使用小寫字母、數字、點 (.) 和連字符 (-)，以字母或數字開頭和結尾，並避免連續句點。',
        bucketNameIsNotIp: '儲存桶名稱不能是IP位址。',
        downloadPermissionLimited: '無法進行此作業，因為您沒有“下載權限”',
        onlyAlbum: '衹有由MultCloud創建或分享的相冊才能被選擇用于存放圖片，視頻等媒體檔案。',
        createFolderFail: '創建文件夾失敗',
        parametersNotEmpty: '雲盤參數不能為空。',
        //mega报错
        addMegaFailed: '某些參數輸入錯誤或您已激活F2A。',
        //mySql报错
        mySqlWarn: '此雲端硬碟無法作為雲端到雲端傳輸的目標雲端硬碟。',
        //2020-10-29ljm新增
        maxTaskRemind: '已達到5000個傳輸/同步任務的上限。請在刪除部分任務後重試。P.S：如果一個任務中包含三個源項目，則該任務將會被記為三個任務。',
        // 2020-11-25 yjs
        torrentTort: '該檔案涉嫌侵權',
        //2020-12-4 xth
        shareNotUpload: '所有者已取消“允許上載”權限，請重新加載此頁面。',
        //2020-12-9 xth
        shareItemUpdate: '分享者已更改分享連結的權限，請重新加載頁面。',
        nameLong: '用戶名不能超過20個字元。',
        notPermission: '您沒有權限对該團隊檔案執行此作業。',
        notOpened: '該雲端硬碟不支援實時同步。',
        taskNotFound: '該任務不存在',
        subscribeFail: '創建任務失敗',
        driveAccountIdInvalid: '無法創建實時同步任務。請刪除並重新添加所選的雲端硬碟賬號，然後重試。',
        unknownState: '無法執行該作業，請稍後再試。',
        InvalidParameter: '無效的參數。',
        InvalidDirectory: 'Box的根目錄不支持該功能。',
        HasExist: '該文件夾即時同步任務已存在，請取消該文件夾的即時同步任務，再重新在該文件夾創建。',
        //   taskRunningNumberLimited:'您只能同時運行5個雲到雲任務，請取消正在執行的任務並重試。',
        taskRunningNumberLimited: '現在已經有2個實時同步任務處於運行狀態，請先暫停其中一個任務。',
        reachedLimit: '已達到該雲端硬碟的速率限制，請稍後重試。',
        selectAlbumWarn: '小貼士：相簿目錄只能儲存圖像、視頻和其他媒體檔案，而不能存儲目錄。',
        notSupported: '當前，即時同步不支援多目標同步任務。',
        incorrectFormat: '抱歉，您的電話號碼格式不正確',
        taskMaximumNumberLimited: '您已達到 200 個實時同步任務的最大數量。 請刪除一些不必要的實時同步任務，然後重試。',
        autoLoginFail: '您已啟用兩步驟驗證，請重新登入。',
        unsubscribeFail: '刪除失敗',
        //2022-4-25 wt
        emptyBucket: '您無法刪除不為空的存儲桶。附言：請確保Wasabi的桶版本控制中也沒有物件。',
        cannotCopyFolder: '不能將資料夾複製到同一個存儲桶中。',
        cannotCopyIdrivee2Folder: '同一Idrive e2帳戶下的資料夾不能互相複製。',
        cannotCutFolder:'同一儲存桶下的資料夾不能互相剪下和貼上。',
        bucketAlreadyExists: '請求的存儲桶名稱不可用。存儲桶命名空間由系統的所有用戶共享。請選擇其他名稱，然後重試。',
        accessPermissionLimited: '您沒有讀取此資料夾的權限。',
        accessDenied: '訪問被拒絕，您無權執行此操作。',
        //云盘操作报错
        alreadyAdd: '您已經添加了該雲端硬碟。',
        toggleWhileEditing:'您新增的帳號與目前帳戶不符。',
        shareTransferCanotCopy: '目前不支援複製多項目共用的根資料夾。',
        // 2020-06-08
        sharePointOnlineNotTrans: '無法選擇Sharepoint根目錄來傳輸檔案，請選擇網站中的子目錄。',
        sharePointListFailed: 'Error 500: InternalServerError。小貼士:請檢查此帳戶是否有權訪問SharePoint服務。',
        sameDirError: '源帳戶和目標帳戶不能相同。',

        accessDenied:'存取被拒絕',
        //iCloudPhotos报错
        onlySaveAlbums: '注意：您選擇的目標目錄只能保存相簿（資料夾）。 ',
        notSelectICloudPhotosRoot: '注意：iCloud相簿的根目錄只能保存相簿（資料夾）。',
        notSelectICloudPhotosForder: '注意：您選擇的目標目錄只能保存相簿（資料夾）。',
        notSelectICloudPhotosAlbum: '注意：您選擇的目標目錄只能保存圖片（不能保存資料夾）。',
        notSelectICloudPhotosOther: '注意：您選擇的目標目錄無法直接保存圖片，所有傳輸的圖片都會保存到“最近”資料夾中。',
        notSelectICloudPhotosBackup: '無法選擇iCloud照片作為“雲端硬碟備份”的目標。 要將圖像保存在iCloud照片中，請選擇“跨雲碟傳輸”或“雲端硬碟同步”。',
        notSelectICloudPhotosSyncRoot: '注意：無法將圖像同步到iCloud照片的根目錄。',
        notSelectICloudPhotosSync: '這是iCloud照片中的資料夾，您只能將圖像同步到iCloud照片的相簿中。',
        sendTooMany: '發送的驗證碼過多。輸入其中一台設備收到的最新驗證碼，或稍後重試。',
        verifySecurityCodeFailed: '驗證失敗，請檢查並重新輸入驗證碼。',
        appleNotEnablePhotos: '你的 Apple ID 並不提供 iCloud 照片。若要使用 iCloud 照片，請使用你用於 Apple 裝置的 Apple ID 登入。',
        tooManyRequests429: '超出用戶速率限制。請在{date}之後重試。',
        tooManyRequests403: '同時發起的請求過多，請稍後重試。',
        // iCloudDrive报错
        folderNameIsTooLong: '資料夾名稱不能超過255個字符。',
        fileNameIsTooLong: '檔案名不能超過250個字符。',
        iCloudDriveNotEnoughSpace: '空間不足，無法上傳檔案。',
        uploadFileIsTooBig: '檔案過大，無法上傳。MultCloud目前限制上傳檔案的大小，最大為 100 MB。',
        uploudFileSizeIsZero: '零位元組的檔案無法上傳至 iCloud 雲碟。',
        notUploudSpecialFile: '無法上傳此類型的檔案至此 App 資料庫。',
        notRenameApp: 'Apple不允許修改App資料夾的名稱，如Pages文稿，Numbers表格和Keynote演講。',
        ErrorDeleteDistinguishedFolder: '無法刪除特殊文件夾。',
        moreThan256Characters: '文件夾名稱不能超過 256 個字符。',
        cloudNotFound: '您已移除該雲端硬碟。',
        fourSharedUnauthorized:'您的4shared授權已過期。請點擊“重新添加”重新授權您的帳戶。',
        fileFolderNameLengthExceed:"檔案/資料夾名稱長度不能超過255個字元。",
        invalidLink: '無效連結。',
        requestFailed: '請求失敗。',
        exceeds2GB: '檔案大小超過 2GB，無法下載。',
        licenseUpgradError: '由於您是 {scheme} 訂閱者，因此無法使用許可證代碼',
        noLicenseCode: '請輸入許可證代碼',
        licenseCodeError: '您輸入的許可證代碼不正確',
    },
    preview: {
        fileNotReview: '檔案無法查看',
        goOringinalSite: '前往原始網站'
    },
    remoteTask: {
        remoteTask: '遠端任務',
        createTask: '創建任務',
        successsExceed: '連結已複製！',
        operateSuccess: '作業成功',
        noRemote: '尚未創建離線任務',
        unKnownError: '未知錯誤',
        undefinedDisk: "無法找到目標目錄，請先複製該任務的連結，再重新創建一個離線任務",
        taskExpired: '該任務已過期，請重新創建任務',
        createDescribe: '將連結檔案、磁力檔案、種子檔案離線保存至雲端硬碟',
        excuteNow: '立即執行',
        noSeeds: '資源較少',
        failedToParse: "解析失敗",
        parseMagnetRunning: '正在解析資源，請稍後...',
        selectedFileLimit: '所選檔案總量不能超過500個或者大小不能超過50G',
        addLink: '新增連結',
        startEmailSend: '任務結束時發送郵件通知',
        nowUpload: '立即上傳',
    },
    shares: {
        myShares: '我的分享',
        savedShares: '保存的分享',
        sharedOn: '分享時間',
        allowedTo: '允許上傳',
        location: '位置',
        shareNull: '您尚未分享任何檔案。',
        shareNullTips: '小貼士：您可以滑鼠右鍵點按該檔案，然後選擇“分享”選項以分享檔案。',
        savedShareNull: '您尚未保存任何分享檔案。',
        savedShareNullTips: '小貼士：如果有人共享了一個共享鏈接給您，您可以將它保存在此處以便快速訪問。',
    },
    login: {
        experienceSigning: '無註冊直接體驗',
        forgotPassword: '忘記密碼?',
        signIn: '登入',
        rememberMe: '記住我',
        keepLogin: '保持登入',
        loginWith: '使用其他賬戶登入',
        email: '電子郵件',
        password: '密碼',
        verificationCode: '驗證碼',
        firstName: '名',
        lastName: '姓',
        confirmPassword: '確認密碼',
        createAccount: '創建賬戶',
        continueWith: '或使用',
        resetMessage: '發送重置訊息',
        enterEmail: '在下面輸入您註冊時使用的電子郵件，我們將向它發送一封包含重置密碼連結的電子郵件。',
        enterCorrectEmai: '請輸入正確的電子郵件地址格式。',
        passwordCharacters: '密碼必須為8-16個字符',
        passwordDiff: '輸入的兩個密碼不一致',
        enterCode: '請輸入驗證碼。',
        sentSuccess: '電子郵件已成功發送',
        successfully: '註冊成功',
        pleaseEmail: '請輸入您的電子郵件',
        pleasePassword: '請輸入您的密碼',
        accountActivated: '您的賬戶還未被啟動',
        enterCorrectPass: '請輸入正確的電子郵件地址或臨時帳戶名和密碼。',
        resetPasseord: '為了保護您的帳戶，請點選※“忘記密碼”以重設密碼。',
        validEmail: '請輸入有效電子郵件',
        enterFirstName: '請輸入您的名字',
        enterLastName: '請輸入您的姓氏',
        reEnterPass: '請重新輸入您的密碼',
        creatingAccount: '建立帳戶即表示您同意',
        termsUse: '使用條款',
        privacyPolicy: '隱私政策',
        thankYou: '感謝您!',
        checkEmail: '請查看您的電子郵件',
        confirmRegistration: '確認您的註冊。您可以跳過啟動過程並正常使用我們的產品，但是如果您忘記密碼，我們將無法幫助您恢復它。',
        noteReceiveEmail: '沒有收到電子郵件?',
        receiveConfirmationEmail: '如果您沒有收到確認電子郵件，請給我們發送電子郵件至',
        buttonResend: '或點選這個按鈕以重新發送。',
        forgetEmail: '已忘記您的電子郵件地址？',
        sendEmailSupport: '發送電子郵件至支援',
        trackDown: '我們會追蹤它。',
        passwordnotMatch: '您輸入的密碼不匹配',
        enterVaildPassWord: '請輸入有效的密碼',
        usernameNotContain: '用戶名不能包含特殊字符',
        updatedSuccessfully: '您的數據已成功更新',
        thankBindEmail: '感謝您綁定電子郵件地址，請及時檢查激活電子郵件',
        failExceedOperation: '無法超過此操作',
        enterNewPassword: '請輸入新密碼',
        ConfirmaçãoPassword: '請輸入確認密碼',
        userNameNot: '用戶名不能為空',
        //login popup用
        signUp: '註冊',
        logInButton: '登入',
        logInWith: '第三方登入',
        logToMultCloud: '登入到MultCloud',
        logEmailInput: '電子郵件/臨時賬號名',
        verificationIncorrect: '輸入的驗證碼錯誤。',
        signUpTitle: '註冊並獲得每月5GB的免費數據流量',
        title: "使用MultCloud將其傳輸到您的雲端存儲服務。",
        tips: "已經有一個帳號？",
        tips2: "沒有賬號?",
        btnTxt: "正在登入……",
        facebook: "Facebook",
        google: "Google",
        exception: {
            strEmpty: "請填寫此字段。",
            nameToLong: "您的用戶名必須是1-20個字符。",
            emailError: "請輸入有效的電子郵件地址。",
            pwdError: "請輸入8-16個字符的密碼。",
            rePsdEmpty: "請重新輸入您的密碼。",
            rePwdError: "密碼不匹配。",
            codeEmpty: "請輸入驗證碼。",
            codeError: "驗證碼必須為4個字符。",
            verifyCodeInvalid: "驗證碼不正確。",
            emailExist: "該電子郵件地址已被註冊。",
            emailPsdError: "電子郵件/臨時賬號名或密碼不正確。",
        }
    },
    home: {
        driveNameNotContain: '驅動器名稱不能包含特殊字符`/ \ | : * ? " < >  &`',
        cloudDiskName: '雲端硬碟名稱不能超過200個字符'
    },
    sharesPage: {
        linkFailure: '抱歉，此分享檔案已被取消。',
        linkMasking: '抱歉，此分享檔案已被阻止查看。',
        saveCloud: '保存到雲端硬碟',
        directDownload: '直接下載',
        saveLink: '保存此連結',
        cancelShare: '取消分享',
        uploadFile: '上載檔案',
        newFolder: '新資料夾',
        saveLinkSuccessBefore: '您已成功保存連接。',
        saveLinkSuccessAfter: '查看已保存的連接',
        saveLinkFail: '保存連接失敗。',
        downloadingFolder: '目前不支援下載資料夾。',
        downloadingMore: '您一次僅能下載一個檔案。',
        downloadingNone: '請選擇一個檔案。',
        sharecanceledSuccess: '分享已取消。',
        sharecanceledFailed: '取消分享失敗。',
        newFolderInRoot: '請在根目錄創建新資料夾。',
        uploadFileInRoot: '請在根目錄上載檔案。',
        selectFileTransfer: '請選擇一個檔案以傳輸。',
        createTransferFailed: '創建傳輸任務失敗。',
        createTransferSuccessBefore: '您已成功創建傳輸任務。',
        createTransferSuccessAfter: '查看任務',
        addCloudService: '添加雲端硬碟',
        mustAddClouds: '您必須添加有效的雲端硬碟',
        selectSaveCloudTitle: '請選擇',
        moreClouds: '更多雲端硬碟',
        saveLinkExists: '此連結已存在。',
        errorShare404: '未找到源檔案。',
        passWordError: '密碼不正確！',
        passWordNone: '密碼不能為空。',
        passWordInputTitle: 'MultCloud私人分享檔案',
        passWordInputMsg: '請輸入密碼。',
        passWordInputButton: '確定',
        loginErrorMax: '您長時間未更新您的密碼，請先更新您的密碼。',
        uploadFolder: '您當前只能上載檔案。',
        pleaseSignIn: '請登入MultCloud。',
    },
    share: {
        noManageMyShare: "您可以在此管理所有分享的檔案。",
        noManageSavedShare: "您可以在此管理所有保存的分享。",
        unknownError: "分享檔案丟失，它可能已被移動或刪除。",
        privateShareText: "（請與我聯絡以獲取密碼）",
    },
    inviteFriends: {
        titleBefor: '邀請盡可能多的朋友，您每邀請一個朋友就會獲得 ',
        titleAfter: ' 流量！沒有配額限制！',
        shareEmailTitle: '分享邀請: ',
        shareLinkTitle: '分享邀請連結: ',
        emailSend: '發送',
        emailTip: '在此添加電子信箱地址',
        wonMonthFlows: '您本月獲得的終身有效跨雲端傳輸流量為: ',
        wonMonthTitle: '有機會贏得無限的終身數據流量！',
        lastWinner: '上一位獲獎者 ',
        winnerInvites: '邀請了{num}位',
        winnerTip: '獲取無限終身流量',
        statusTitle: '您的分享狀態',
        successInvites: '本月成功邀請: ',
        chanceWin: '獲勝機會: ',
        tipsTitle: '說明',
        tipsOne: '只有被邀請的用戶驗證了電子郵件才能算作成功邀請。',
        tipsTwo: '邀請他人所獲得的流量沒有配額限制。',
        tipsThird: '如果您已經是無限流量的訂閱用戶，那麼當您邀請成功時無法獲得2GB的流量，但您獲得終身無限服務的機會將增加一倍。',
        shareText: 'MultCloud - 在一個平台傳輸和管理您的多個雲端硬碟。今天加入MultCloud，立即獲得2 GB跨雲端傳輸流量獎勵!',
    },
    paySystem: {
        billed: '以$0.099/GB的單價購買額外流量',
        subCould: '如果流量仍不夠用，訂閱用戶可以按照50GB/$5.9或100GB/$9.9的價格購買流量。',
        limitedMonth: '150GB/每月',
        limitedTrafficMonth: '150GB 流量/每月',
        unlimitedTraffic: '終身無限流量！',
        foraYear: '一年無限流量',
        noNeedPurchase: '無需購買額外流量',
        yearlyPayment: '按年付費(NT$216.58/每月)',
        validityData: '您購買的流量終身有效',
        additionalPackage: '額外流量包',
        subscriptmc: '您的MultCloud訂閱方案',
        upgradeMore: '升級到MultCloud付費版即可享受更多的流量與額外的功能',
        recommended: '推薦方案',
        toUnlimited: '升級到無限版',
        otherPlan: '其他方案',
        moreTraffic: '購買更多流量',
        monthlySubscriber: `您是月度方案訂閱用戶，而您每月將擁有150GB流量可以在雲端硬碟之間傳輸或同步資料。`,
        moreDetails: `<a class='add-cloud-link sysLink'>更多特權詳情</a>`,
        dataTraffic: '本月流量使用情況',
        cloudTraffic: '跨雲端流量',
        buyNow: '立即購買',
        specialOffer: '特別優惠',
        lifetimeFree: '終身免費',
        unsubscribe: '取消訂閱',
        includes: '包含',
        reSubscription: '啟動訂閱',
        monthTraffic: '一月無限流量',
        threeMonth: '30GB/每月',
        monthlyPayment: '按月付費',
        monthlyUnlimited: '月度無限',
        gb: 'GB',
        YearlyUnlimited: '年度無限',
        YearlyPaymentNine: '按年付費(NT$291.58/每月)',
        Onetime: '一次性付費',
        twoMonthree: '200GB/每月 x3',
        QuarterlyPayment: '按季付費(NT$243/每月)',
        fourMOne: '400GB/每月 x12',
        quarterlySubscriber: `您是季度方案訂閱用戶，而您每月將擁有200GB流量可以在雲端硬碟之間傳輸或同步資料。`,
        yearlySubscriber: `您是年度方案訂閱用戶，而您每月將擁有400GB流量可以在雲端硬碟之間傳輸或同步資料。`,
        expireIn: '到期時間',
        billYearly: '每年支付',
        billMonthly: '每月支付',
        billQuarterly: '每季支付',
        twoMonTrafficthree: '200GB 流量/每月 x3',
        fourMTrafficOne: '400GB 流量/每月 x12',
        deleteSubAccount: '您必須取消訂閱才能刪除帳戶，確定要這樣做嗎？',
        payFirst: '您必須先',
        paybindEmail: `<a class='add-cloud-link sysLink'>綁定並驗證您的郵件地址</a>`,
        payEnd: '才能訂閱，因為我們需要確保您能夠收到與訂閱相關的重要郵件。',
        yearlyPaymentTxt: '按年付費',
        quarterlyPaymentTxt: '按季付費',
        //2021-5-20新加
        upUnlimited: '升級到年無限',
        //2
        payDiff: '僅支付差價！',
        //3
        yearlyUnlimit: 'MultCloud (<b>無限年</b>)',
        //4
        providesUnlimited: '無限年計劃提供無限的數據流量，以在雲存儲服務之間傳輸或同步數據，為期12個月',
        //5
        subProduct: '.這是一種訂閱產品，每年收費',
        perYear: '。',
        cancelSubscription: '您可以隨時取消訂閱。',
        //6
        defaultPayment: '默認付款方式是',
        //7
        anotherPayment: '如果您想使用其他付款方式，請',
        clickHere: '點擊此處。',
        //8
        tryAgain: '付款暫時無法完成。 請檢查您的付款方式，然後重試。',
        //9
        contactPayment: '如果付款有問題,請隨時聯繫<a href="mailto:support@multcloud.com">support@multcloud.com</a>',
        //10
        Notice: '通知',
        beforeBind: '請在升級會員前綁定您的郵箱。',
        processorder: '訂單處理中',
        eachGbMoney: 'NT$3.58/',
        eachGbMoneyT: 'NT$2.99/',
        payCouponQuartly: '按季付費(NT$186.33/每月)',
        payCouponlimitedYearly: '按年付費(NT$166.58/每月)',
        payCouponunlimitedYearly: '按年付費(NT$216.58/每月)',
        payCouponunlimitedYearlyLow: '按年付費(NT$194.92/每月)',
        tips: '溫馨提示：如果您有任何疑問，歡迎聯繫 <a href="mailto:support@multcloud.com">support@multcloud.com</a>.',
        monthly: '每月150GB',
        //新版付费页面
        payTitle: '選擇最適合您的MultCloud！',
        limitedData: '有限數據',
        unlimitedData: '無限數據',
        monthly: '月付',
        annually: '年付',
        save58: '節省58%',
        payTip: '聯繫我們的銷售團隊',
        limitTips: '未使用的數據流量會累積',
        unlimitTips: '不再有數據限制問題',
        tips2: '如果您在購買過程中遇到任何問題，請隨時與我們聯繫：<a href="mailto:support@multcloud.com">support@multcloud.com</a>',
        vipUpgradeTips: '這是提供給{type}計劃使用者的優惠。',
    tabPayScheme: {
            perMonth: '月付',
            perYear: '年付',
            perNextYear: '第一年（續訂 {price}）',
            refundDays: '天的退款保證',
            advanced: '高級功能',
            payPremium: '升級到任何高級版本，就能享受以下所有的高級功能 ',
            payUnlimited: '升級到任何無限版本，就能享受以下所有的高級功能',
            freeTip1: '更多的雲到雲數據流量',
            freeTip2: '無限的雲到雲數據流量',
            freeTip3: '自動傳輸/同步/備份',
            freeTip4: '雙重同步',
            freeTip5: '10個傳輸線程',
            freeTip6: '8種同步模式',
            freeTip7: '檔案篩選服務',
            freeTip8: 'VIP傳輸伺服器',
            freeTip9: 'VIP客戶服務',
            freeTip10: '同時運行5個雲到雲任務',
            freeTip11: '無限電子郵件轉換',
            freeTipTitle1: '訂閱者可以同時創建2個實時同步任務和2個普通同步任務(總共4個)。',
            freeTipTitle2: '訂閱者可使用10個傳輸線程，而免費用戶可使用2個傳輸線程。',
            freeTipTitle3: '雙向同步和7個自定義單向同步的選項，支持鏡像同步。',
            freeTipTitle4: '設置過濾器以自動傳輸或同步帶有自定義檔案名或其他副檔名的檔案。',
            freeTipTitle5: '訂閱用戶可以同時運行5個雲到雲任務，而免費用戶只能同時運行1個任務。',
            freeTipTitle6: '訂閱者可以將無限數量的電子郵件轉換為PDF，而免費用戶每月只能轉換50封電子郵件。',
        },
        nowPayScheme: {
            clearInsCountText: '但未使用的 Instagram 個人資料下載配額將被清除。',
            manageYourPlan: '管理您的訂閱',
            price: '價格',
            paymentMethon: '付款方式',
            autoRenewal: '自動續訂',
            priceVat: '包括 {currency}{vatPrice}增值稅 ({currency}{netPrice}的{percent}%)。',
            defaultPayment: '{method}, xxxxxxxx{num}。',
            paypalPayment: '默認支付方式為PayPal。',
            changePayment: '修改支付方式',
            activated: '下一個帳單日期 {time}',
            deactivated: '下一個帳單日期 {time}',
            appleTip: '您當前的{name}是在Apple Store中購買的。',
            appleTipId: 'Apple交易ID：{id}。',
            googleTip: '您當前的{name}是在Google Play中購買的。',
            googleTipId: 'Google Play訂單ID：{id}.',
            appNextTimeTip: '自動續訂已啟動。下一個計費日期为{time}。',
            appNoSubscribe: '自動續訂已停用。',
        },
        // 免费用户弹窗
        freePlanPopup: {
            title_traffic: '雲端到雲端傳輸流量不足',
            title_ins: '您已達到下載限制',
            title_pdf: '您已達到電子郵件轉換為 PDF 的数量限制',
            title_modes: '您選擇的同步模式是高階方案獨有的計劃',
            title_remote: '您已達到遠端上傳的限制',
            title_subtasks: '升級到付費方案即可傳輸更多子帳號',
            title_scheduled: '預定傳輸/同步/備份是進階計畫獨有的計劃',
            title_speed: '五倍傳輸速度是高階計畫獨有的計劃',
            title_sync: '您已達到普通同步的限制',
            title_real: '您已達到即時同步的限制',
            title_filter: '檔案過濾器是高級計劃獨有的計劃',
            desc: '升級以解鎖所有高級功能',
            itemTitle_th: '特點和優點',
            itemTitle_traffic: '雲端到雲端流量',
            itemTitle_ins: '下載Instagram個人資料',
            itemTitle_pdf: '將電子郵件轉換為PDF',
            itemTitle_modes: '同步模式',
            itemTitle_remote: '平行遠端上傳任務數量',
            itemTitle_subtasks: '團隊間子帳戶遷移數量',
            itemTitle_scheduled: '定時傳輸/同步/備份',
            itemTitle_speed: '傳輸速度',
            itemTitle_sync: '平行正常同步的任務數量',
            itemTitle_real: '平行即時同步任務數量',
            itemTitle_filter: '檔案過濾',
            itemTitle_tran: 'VIP傳輸伺服器',
            itemTitle_customer: 'VIP客戶支援',
            itemTitle_watermark: '從轉化為PDF的郵件移除浮水印',
            itemValue_cur: '當前',
            itemValue_free: '免費',
            itemValue_upgrade: '升級到',
            itemvalue_premium: '進階版',
            itemvalue_5gb: '5 GB / 月',
            itemvalue_1profile: '1個人資料 / 月',
            itemvalue_50emails: '50封電子郵件 / 月',
            itemvalue_maxUnlimited: '最大無限制',
            itemvalue_unlimited: '無限',
            button: '升級僅需 NT$286 起',
        },
        // 套餐的支持项
        supportItem: {
            yourCurPlan: '當前方案',
            // 第1组
            gb5: '每月5GB的免費數據流量',
            gb100: '每月100GB的數據流量',
            gb200: '每月200GB的數據流量',
            gb1200: '每年1200GB的數據流量',
            gb2400: '每年2400GB的數據流量',
            gbUnlimitedYear: '年度無限數據流量',
            gbUnlimitedLifetime: '終身無限數據流量',
            gbPackage50: '',
            gbPackage100: '',
            gbGiveAway500: '',
            gbGiveAway200: '',
            ins1: '每月可下載 1 個 Ins 個人檔案',
            ins10: '每月可下載 10 個 Ins 個人檔案',
            ins20: '每月可下載 20 個 Ins 個人檔案',
            ins120: '每年可下載 120 個 Ins 個人檔案',
            ins240: '每年可下載 240 個 Ins 個人檔案',
            insPackage50: '',
            insPackage100: '',
            insGiveAway500: '',
            insGiveAway200: '',
            pdf50: '每月轉換50封電子郵件',
            pdfUnlimited: '無限次電子郵件轉換',
            threads2: '2個用於數據傳輸的線程',
            threads10: '10個用於數據傳輸的線程',
            scheduled: '計劃的傳輸/同步/備份',
            // 第2组
            acrossClouds: '跨雲傳輸/同步/備份',
            offline: '離線傳輸/同步/備份',
            subAccounts3: '在團隊之間遷移3個子帳戶',
            subAccounts1000: '在團隊之間遷移1000個子帳戶',
            highSpeed: '快速的數據傳輸',
            // 第3组
            syncMode4: '4種單向/雙向同步模式',
            syncMode10: '10種單向/雙向同步模式',
            realSync: '即時同步',
            passwordProtected: '密碼保護的共用',
            subAccounts: '子賬戶協作',
            // 第4组
            cloud30: '30+ 領先的雲端存儲服務',
            unlimitedCloud: '添加無限的雲端存儲帳戶',
            singleLog: '單次登錄所有雲端帳戶',
            support365: '24/7/365優先支援',
            // 其他
            unlimitedDataTraffic: '無限的雲端到雲端數據流量',
            unlimitedInsProfile: '無限下載Instagram個人資料',
            unlimitedAllFeatures: '所有進階功能',
            // VIP弹窗标题
            vipPopupTitleTraffic: '您已耗盡所有數據流量',
            vipPopupDescTraffic: '升級以解鎖無限數據流量',
            vipPopupTitleIns: '您已使用Instagram個人資料的所有下載次數',
            vipPopupDescIns: '升級以解鎖無限下載Instagram個人資料',
        },
        //套餐arguments参数翻译
        arguments: {
            //参数名
            title: {
                monthly100GB: '100GB/月',
                monthly200GB: '200GB/月',
                monthlyUnlimit: '無限數據/月',
                yearly1200GB: '1200GB/年',
                yearly2400GB: '2400GB/年',
                yearlyUnlimit: '年度無限方案',
                lifetimeUnlimit: '終身無限方案',
                package50GB: '50GB',
                package100GB: '100GB',
                giveAway500GB: '500GB',
                giveAway200GB: '200GB',
            },
            tips: {
                monthly100GB: '例如，您在第一個月只消耗了100GB中的50GB，而在下個月您仍將擁有50GB的額外數據流量。',
                monthly200GB: '例如，您在第一個月只消耗了200GB中的150GB，而在下個月您仍將擁有50GB的額外數據流量。',
                monthlyUnlimit: '',
                yearly1200GB: '例如，您在第一年只消耗了1200GB中的1000GB，而在第二年您仍將擁有200GB的額外數據流量。',
                yearly2400GB: '例如，您在第一年只消耗了2400GB中的2000GB，而在第二年您仍將擁有400GB的額外數據流量。',
                yearlyUnlimit: '',
                lifetimeUnlimit: '',
                package50GB: '例如，您本月只消耗了50GB中的20GB，未使用的30GB仍將保留在下個月。',
                package100GB: '例如，您本月只消耗了100GB中的20GB，未使用的80GB仍將保留在下個月。',
            }
        },
    },
    //双重验证功能
    twoStepverification: {
        bind: '請先綁定郵箱',
        addVerify: '您必須添加驗證方式。',
        phoneNotEmpty: '電話號碼不能為空。',
        addPhone: '添加電話號碼',
        addAlEmail: '添加備用電子郵箱地址',
        verifySet: '驗證設置',
        addWayVerify: '添加驗證方式',
        enterEmail: '輸入您的電子郵箱地址',
        enterPhone: '輸入您的電話號碼',
        enterCode: '請輸入我們發送的驗證碼',
        enterCodeTip:'請檢查您的垃圾郵件資料夾並報告不是垃圾郵件或將“no-reply@multcloud.email”添加到您的白名單中。',
        codeExpired: '驗證碼已過期',
        codeinCorrect: '驗證碼不正確，請檢查驗證碼並重試。',
        verificationTurnOn: '開啟雙重驗證',
        recoverAccess: '如果您需要恢復對賬號的訪問權限，此代碼將有所幫助。您應該將其寫下來並存放在安全的地方。我們強烈建議您不要將恢復代碼存儲在設備上。',
        longValid: '如果您以前有恢復代碼，則它不再有效。請改用此新恢復代碼。',
        removeAll: '移除所有設備？',
        lostAccess: '如果您無法訪問您信任的設備，我們建議您執行此作業。',
        removeMethod: '刪除驗證方法？',
        removeMethodSure: '您確定要刪除驗證方法嗎？刪除它意味著您將無法使用它進行驗證。',
        getRecode: '生成新恢復碼',
        emailCode: '通過電子郵件發送代碼',
        TextCode: '通過簡訊發送代碼',
        useAccount: '您現在使用的是臨時賬號，請綁定郵箱地址，然後重試。',
        removeTrusted: '移除所有受信任的設備',
        finish: '完成',
        newCode: '您的新驗證碼是',
        twoStep: '雙重驗證',
        twoStepis: '雙重驗證已',
        on: '開啟',
        off: '關閉',
        cancel: '取消',
        toManyCodeSend: '驗證碼發送過於頻繁',
        verifyIdenti: '驗證身份',
        codeCopied: '密碼已複製!',
        copyCode: '複製密碼',
        trustedDevice: '已移除受信任的設備！',
        phoneValueTips:'提示： 請删除前導零，並删除所有空格、破折號或括號。',
    },
    cloudBackup: {
        cloudBackup: '雲端硬碟備份',
        setUpCloud: '設置雲端硬碟備份任務，將在線檔案從一個雲端硬碟備份到另一個雲端硬碟',
        filesBckupTarget: '目標目錄',
        filesBckup: '檔案備份',
        selectSoure: '按一下此處選擇要備份的源雲端硬碟檔案',
        saveBackup: '備份位置',
        selectTarget: '單擊此處選擇目標雲端硬碟以保存備份',
        backupNow: '立即備份',
        canSelect: '最多可選擇10000個項目',
        backupFiles: '您無法將檔案備份到Google相簿。',
        notSelectEvernoteBackup: '您無法將檔案備份到Evernote。',
        backFlickr: '您無法將檔案備份到Flickr。',
        thankSubscrib: '感謝您訂閱我們的服務，您現在最多可以同時備份10個檔案。',
        maximunBack: '您現在最多可以同時備份2個檔案。升級到任何高級服務后，最多可備份10個！',
        backSuccess: '備份成功',
        backFailure: '備份失敗',
        successBck: '成功備份所有檔案',
        taskCanceled: '任務被手動取消',
        notRestore: '找不到要恢復的檔案。它們可能已經被刪除。',
        selectVersions: '選擇版本',
        restoreOptions: '恢復選項',
        selectFiles: '選擇要恢復的檔案。',
        toRestore: '請選擇一個檔案進行恢復。',
        originalLocation: '原始位置',
        thankRestore: '感謝您訂閱我們的服務，您現在最多可以同時恢復10個檔案。',
        restoreSimult: '您現在最多可以同時恢復2個檔案。升級到任何高級服務后，最多可恢復10個！',
        restoreSuccess: '恢復成功',
        restorePartial: '部分恢復成功',
        restoreFailure: '恢復失敗',
        notRestore: '找不到要恢復的檔案。它們可能已經被刪除。',
        backupTime: '備份時間',
        changedFiles: '已更改的檔案',
        deleteVersion: '確定要刪除備份版本嗎？',
        deleteFiles: '刪除此版本中的檔案',
        keepLatest: '保留最新檔案',
        overWriteFile: '覆蓋檔案',
        skipFile: '跳過檔案',
        versions: '版本',
        backupTask: '備份任務',
        readdCloud: '重新添加雲端硬碟',
        selectedCloud: '在雲備份發布之前，部分選定的雲端硬碟已添加到MultCloud，我們建議您將這些雲端硬碟重新添加到MultCloud並重試。',
        continueAnyway: '仍然繼續',
        selectedHasAdded: '選定的雲端硬碟在雲備份發布之前已添加到MultCloud，我們建議將這些雲端硬碟重新添加到MultCloud並重試。',
        failCreate: '創建備份任務失敗。',
        failLoad: '加載失敗',
        pleaseReAdd: '請將雲端硬碟重新添加到MultCloud。',
        alreadyAdd: '您已經添加了該雲端硬碟。',
        failRename: '未找到對應的資料夾，重命名失敗',
        taskRuning: '任務正在運行，待任務結束後再試',
        //2021-08-07添加
        restoreOriginal: '恢復到初始位置',
        restoreNewLocation: '恢復到新位置',
        backingUp: '備份中',
        restoring: '還原中',
        restore: '還原源',
        backup: '備份源',
        //2021-08-17添加
        maxNum: '源項目的最大數量為 1000，請少選項目。 P.S.整個文件夾只計算一個項目。',
        maxLogs: '溫馨提示：結果被截斷。此處只能顯示1000個失敗的檔案。',
        backupDetails: '備份詳情',
        keepTwoFile: '保留兩個文件',
        restoreDetails: '還原詳細信息',
        longerDelete: '找不到目標目錄。',
        //2021-10-20
        backupNotWork: '備份服務不可用',
        //2021-10-28
        backupPartial: '備份部分成功',
        configFile: '(正在上傳配置檔案)',
        successRestore: '成功還原所有檔案。',
        notFind: '找不到設定檔，請檢查設定檔是否存在，以及雲端硬碟和MultCloud之間的連接是否有效。',
        selectRestoreItems: '請選擇您要恢復的檔案。',
        selectRestoreTotles: '請選擇目錄以恢復檔案。',
        original: '來源雲端',
        inTotalTip: '{count}個文件，共{size}',
    },
    affiliateProgram: {
        leftTitle: "成為我們的代理商",
        title: "MultCloud加盟計劃",
        headTips1: "賺取高達 <span>50%</span> 的佣金率。",
        headTips2: "只需點擊幾下即可註冊，絕對<span>免費</span>。",
        headTips3: "沒有附加條件，<span>任何人</span>都可以成為我們的代理商！",
        signUpBtn: "註冊代理商賬號",
        tips: "提示：如果您已經是 Cleverbridge 的代理商，請直接<a href=\"https://console.partnerize.com/campaigns/manage-campaigns/join-campaigns/advertiser-details/1011l331\" target=\"_blank\">登入</a>。",
        howDoTipsTitle: "它是如何工作的",
        howDoTipsMsg: "一旦您註冊並登入了我們的代理商平台，您將在“Campaigns - Join Campaign”標籤下看到AOMEI International Network Limited。之後點擊並加入該Campaign。一旦您加入了我們的Campaign，您將可以看到所有可售賣的MultCloud產品。如果有人通過您的推薦鏈接升級 MultCloud，您將獲得<span>30%-50%</span>的佣金率。",
        FAQsTitle: "MultCloud 加盟計劃的常見問題",
        FAQ1: "加盟計劃如何運作？",
        answer1: "一旦您的客戶通過您的推薦頁面付款，您將在下個月初獲得酬金。",
        FAQ2: "聽起來不錯。那麽如何註冊？",
        answer2: "您可以通過點選上面的“註冊代理商賬號”進行註冊。只需幾步，您就可以擁有您的代理商賬號。",
        answerPs2: "溫馨提示：登入控制台後，您可以在\"Campains\"標籤下找到AOMEI International Network Limited，點擊並確認加入。",
        FAQ3: "我能獲得多少佣金？",
        answer3: "佣金因訂閱方案不同而不同。例如，月度方案對應的佣金率為30%，而終身無限版對應的佣金率為50%。",
        FAQ4: "如何獲得酬金？",
        answer4: "這取決於您填寫的“收款方式”。酬金會在每個月月初發放給您。",
        answerPs4: "溫馨提示：每次酬金發放沒有最低金額限制。",
        anyQuestionTitle: "是否有疑問？",
        anyQuestionTip: "請隨時聯繫：<a href=\"mailto:affiliate@multcloud.com\" class=\"alink\">affiliate@multcloud.com</a>",
    },
    signUp: {
        pwdTip: "密碼（8-16 個子元）",
        signingUp: "註冊......",
        tips2: "創建帳號即表示您接受<a href=\"https://www.multcloud.com/tw/terms\" class=\"alink\">服務條款<a/>和<a href=\"https://www.multcloud.com/tw/policy\" class=\"alink\">隱私政策<a/>。",
        emailPushTip: "勾選此複選框即表示您同意接收MultCloud發來的有關產品、服務更新、特別優惠和活動的電子郵件。您可以隨時取消訂閱。",
    },
    forgetPwd: {
        title: "忘記密碼？",
        tip: "輸入您的電子郵件地址，我們將向您發送一個連接來重置您的密碼。",
        sending: "發送消息...",
        btnTxt: "發送重置電郵",
        tips1: "忘記了您的電子郵件地址？",
        tips2: " 發送電郵給技術支持",
        tips3: "我們將盡力找回。",
    },
    balackFriday: {
        lastTip: "行動要快，以免向隅",
        title: "搶先體驗黑色星期五和網路星期一，以70%的折扣獲得無限雲到雲數據流量！",
        titleTip: "抓緊時間，僅此一次！",
    },
    christmas: {
        payTxt: "聖誕促銷",
        popupTitle: "MULTCLOUD超級特賣",
        pageTitle: "以{num}%的折扣獲得終身無限雲到雲數據！",
        pageTitle2: "以{num}%的折扣獲得終身無限雲到雲數據！",
        paysysTitle: "抓緊時間購買！",
        popupTip1: "無限的雲到雲數據",
        popupTip2: "10個高速數據傳輸線程",
        popupTip2Append: "高級使用者有10個傳輸線程，免費使用者有2個傳輸線程",
        popupTip3: "計劃傳輸/同步/備份",
        popupTip4: "單向/雙向實時同步",
        popupTip4Append: "高級用戶還有7種額外的同步模式，其中支援鏡像同步",
        saledBtn: "立即購買",
    },
    teamTransfer: {
        teamTransfer: '團隊遷移',
        transferMultiple: '將多個帳戶從一個雲平台遷移到另一個雲平台 (Google Workspace、OneDrive for Business、Dropbox Business、Box for Business, Shared Drive).',
        businessCloud: '如果您是企業雲端硬碟的管理員，您可以使用此功能輕鬆地將所有帳戶從一個企業雲端硬碟到另一個。例如，每個用戶在雲端硬碟平台上都會有一個自己的資料夾，MultCloud可以自動將來自兩個不同企業雲端硬碟的資料夾進行配對，並將檔案從一個雲端硬碟遷移到另一個。',
        clickSelect: '點選此處以選擇要從其傳輸的企業雲端服務。',
        sourceAccount: '源賬戶',
        targetAccounts: '目標賬戶',
        autoMatch: '自動匹配',
        likeTransfer: '點選此處以選擇您要傳輸到的企業雲端服務。',
        youMust: '您需要先以管理員身份',
        cloudService: '添加',
        asAdmin: '企業雲端服務。',
        combinations: '自動匹配將清除當前組合，您確定要繼續嗎？',
        nosourceAccount: '沒有源帳戶或目標帳戶。',
        noAccount: '沒有自動匹配的帳戶。',
        uploadCSV: '上傳CSV',
        cleanCurrent: '上傳CSV會清理當前的組合，您確定要繼續嗎？',
        csvFile: '您上傳的CSV檔案應符合',
        csvFormat: '.CSV格式。',
        matchCsv: '該組織無法匹配CSV檔案中的任何組合，請檢查CSV檔案並重試。',
        alreadyAdd: '您已經添加了這兩個帳戶的組合。',
        cleanAll: '您即將清理所有選定的組合，確定要繼續嗎？',
        sure: '是的，我確定',
        allTransferred: '將所有傳輸的檔案保存在一個資料夾中。',
        newTrans:'遍歷開始時開始傳輸。',
        optionActivated: '如果啓動此選項，所有傳輸的檔案將保存在目標雲端硬碟的一個資料夾中。例如，源目錄為 Google Workspace\\simon@multcloud.com，目標目錄為 OneDrive for Business\\peter@multcloud.com，則啟動此選項後，Google Workspace\\simon@multcloud.com 中的所有檔案都將轉移到 OneDrive for Business\\peter@multcloud.com\\simon@multcloud.com。',
        newTransTip: '支援的任務：1. 來源必須是一個資料夾 2. 來源是雲端硬碟，而非電子郵件 3. 目標不是以照片為主的雲端硬碟',
        organizationMigration: '組織遷移',
        //jimin新增
        downloadCSV: '下載 CSV',
        dontShow: '不再顯示此內容',
        notSelected: '無法選擇Google Workspace共用雲端硬碟作為團隊遷移的目標雲端硬碟。',
        batchMatch: '批量匹配',
        sourceCloud: '添加源雲盤',
        targetCloud: '添加目標雲盤',
        subTaskLimit: '子任務限制',
        freeUsers: '免費用戶可以在一個團隊遷移任務中創建3個子任務。請升級到高級版本，從而在一個團隊遷移任務中創建1000個子任務。',
        mostTeamTransfer: '團隊遷移中的3個子任務',
        substasksMost: '團隊遷移中的1000個子任務',
        mostTasks: '子任務個數最多為1000個。',
        timePassed: '所選時間無效',

    },
    shareTransfers: {
        logoMsg: '<span class="sf-logo-first">MultCloud</span><span class="sf-logo-name">傳輸</span>',
        addFiles: '從雲端硬碟添加檔案',
        trnsfering: '正在傳輸……',
        sendFile: '發送{num}個檔案',
        sendingSize: '{num}/{all}',
        sendingTip: '正在創建傳輸連結，請稍候。',
        cancelTransfer: '取消本次傳輸？',
        createdTransfer: '傳輸任務已創建！',
        createShare: '創建傳輸任務',
        signTitleByTransfer: '登入Multcloud以繼續',
        signupTitleByTransfer: '註冊Multcloud以繼續',
        transferTitle: '標題',
        transferDescription: '描述',
        addFileTip: '已添加{num}個檔案',
        titleErrMsg: '標題不應超過 128 個字元。',
        desErrMsg: '描述不應超過 512 個字元。',
        folder: '資料夾',
    },
    summerSale: {
        titleTip: '夏天你好',
        titleTip2: '獲得無限的雲端硬碟到雲端硬碟數據流量，並以優惠的價格輕鬆管理您所有的夏日回憶！',
        bottomTip: '- 本季最佳優惠 -',
    },
    halloweenSale: {
        titleTip2: '只給糖不搗蛋！以高達70%的折扣獲得無限的雲到雲數據流量。',
        bottomTip: '抓緊時間！以免向隅。',
    },
    newYear: {
        payTxt: "新年特賣",
        titleTip: '辭舊迎新鐘聲響，盡享70%的無限跨雲碟傳輸流量！',
        bottomTip: '快！即將結束了！',
    },
    backToSchool: {
        titleTip2: '以優惠的價格獲取無限的雲到雲數據流量並管理您所有的校園記憶！',
        bottomTip: '- 本季最佳優惠 -',
    },
    blackFriday: {
        titleTip: '享受無限跨雲碟傳輸流量的3折優惠。',
        bottomTip: '快！即將結束了！',
    },
    xmas: {
        titleTip: '聖誕節盡享70%的無限跨雲碟傳輸流量！',
        bottomTip: '快！即將結束了！',
    },
    license: {
        codeTitle: '輸入許可證代碼',
        codeTipTitle: '輸入許可證代碼',
        codeTipText: '如果您有許可證代碼，可以使用它來啟動高級服務。',
        codeTipTextVip: '如果您有許可證代碼，可以使用它升級到更高級的服務。',
        codeFooter: '如果您需要任何協助，請隨時聯絡： ',
        showTitle: '許可證代碼',
        showTip: '許可證代碼為：',
        codeSucTitle: '已啟用高級服務',
        codeSucTip: '已啟用高級服務！',
    },
    filters: {
        taskList: {
            typeName: '類型',
            type: {
                all: '全部列表',
                copy: '臨時任務',
                transfer: '跨雲碟傳輸',
                sync: '雲端硬碟同步',
                backup: '雲端硬碟備份',
                business: '團隊遷移',
                remoteUpload: '遠端任務',
                emailMigration: '郵件傳送',
            },
            statusName: '狀態',
            status: {
                all: '全部狀態',
                preset: '預設',
                running: '執行中',
                success: '成功',
                patial: '部分成功',
                failed: '失敗',
                canceled: '已取消',
            },
            dateName: '日期',
            date: {
                all: '全部時間',
                today: '今天',
                latestWeek: '最近一週',
                latestMonth: '最近一個月',
                customDate: '自訂日期',
            },
        }
    },
    schedule: {
        week1: "週日",
        week2: "週一",
        week3: "週二",
        week4: "週三",
        week5: "週四",
        week6: "週五",
        week7: "週六",
    },
    inputTab: {
        filterMessage: '按下 Enter 鍵以新增檔案副檔名',
    }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/traditional_Chinese.js